import { GetSituacaoDataValidService } from "./../shared/services/getSituacaoDataValid.service";
import { WebTempTermoExtratoBPD } from "./../shared/models/WebTempTermoExtratoBPD.model";
import { WebTempTermoExtratoBPDService } from "./../shared/services/WebTempTermoExtratoBPD.service";
import { WebTempTermoExtratoDesligamentoService } from "./../shared/services/WebTempTermoExtratoDesligamento";
import { PlanoParticipanteService } from "./../shared/services/planoParticipante.service";
import { LoginStore } from "./../shared/store/login.store";
import { Component, OnInit } from "@angular/core";
import { Adesao } from "../shared/models/adesao.model";
import { AdesaoService } from "../shared/services/adesao.service";
import { MatDialog, MatSnackBar, MatTabChangeEvent } from "@angular/material";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { PessoaService } from "../shared/services/pessoa.service";
import { WebTempDependenteService } from "../shared/services/webTempDependente.service";
import { WebTempDependente } from "../shared/models/webTempDependente.model";
import { Pessoa } from "../shared/models/pessoa.model";
import { FinalidadeService } from "../shared/services/finalidade.service";
import { Finalidade } from "../shared/models/finalidade.model";
import { WebStatusRegistro } from "../shared/models/webStatusRegistro.model";
import { WebStatusRegistroService } from "../shared/services/webStatusRegistro.service";
import { WebStatusObsService } from "../shared/services/webStatusObs.service";
import { WebStatusObs } from "../shared/models/webStatusObs.model";
import { MatTableDataSource } from "@angular/material";
import { SelectionModel } from "@angular/cdk/collections";
import { WebAlterarCadastroTemp } from "../shared/models/webAlterarCadastroTemp.model";
import { WebHistContribuicaoPercentual } from "../shared/models/webHistContribuicaoPercentual.model";
import { WebHistContribuicaoPercentualService } from "../shared/services/webHistContribuicaoPercentual.service";
import { WebRelacaoDocumentos } from "../shared/models/webRelacaoDocumentos.model";
import { WebRelacaoDocumentosService } from "../shared/services/webRelacaoDocumentos.service";
import { WebUploadDocumentos } from "../shared/models/webUploadDocumentos.model";
import { WebPerfilPlanoParticipanteService } from "../shared/services/webPerfilPlanoParticipante.service";
import { WebHistPlanoParticipante } from "../shared/models/webHistPlanoParticipante.model";
import { WebPlanoParticipanteService } from "../shared/services/webPlanoParticipante.service";
import { WebHistPlanoParticipanteService } from "../shared/services/webHistPlanoParticipante.service";
import { WebPlanoParticipante } from "../shared/models/webPlanoParticipante.model";
import { WebPerfilPlanoParticipante } from "../shared/models/webPerfilPlanoParticipante.model";
import { PlanoParticipanteADOService } from "../shared/services/planoParticipanteADO.service";
import { PlanoParticipanteADO } from "../shared/models/planoParticipanteADO.model";
import { PerfilPlanoParticipante } from "../shared/models/perfilPlanoParticipante.model";
import { HistPlanoParticipante } from "../shared/models/histPlanoParticipante.model";
import { PessoaADO } from "../shared/models/pessoaAdo.model";
import { DadosBancariosADOService } from "../shared/services/dadosBancariosADO.service";
import { DadosBancariosADO } from "../shared/models/dadosBancariosADO.model";
import { DadosBancoADO } from "../shared/models/dadosBancoADO.model";
import { HistContribuicaoPercentual } from "../shared/models/histContribuicaoPercentual.model";
import { HistContribuicaoPercentualService } from "../shared/services/histContribuicaoPercentual.service";
import { AutoPatrocinio } from "../shared/models/autoPatrocinio.model";
import { WebInclusaoDependenteTempADO } from "../shared/models/webInclusaoDependenteTempADO.model";
import { WebStatusSeguradoraService } from "../shared/services/webStatusSeguradora.service";
import { WebStatusSeguradora } from "../shared/models/webStatusSeguradora.model";
import { DependenteFinalidadeADO } from "../shared/models/dependenteFinalidadeADO.model";
import { DependenteADO } from "../shared/models/dependenteADO.model";
import { WebContratoSeguroService } from "../shared/services/webContratoSeguro.service";
import { WebContratoSeguro } from "../shared/models/webContratoSeguro.model";
import { WebContratoSeguroRespostas } from "../shared/models/webContratoSeguroRespostas.model";
import { WebContratoSeguroRespostasService } from "../shared/services/webContratoSeguroRespostas.service";
import { WebEsteiraProcessoFluxo } from "../shared/models/webEsteiraProcessoFluxo.model";
import { TermoContribuicaoVoluntariaService } from "../shared/services/termoContribuicaoVoluntaria.service";
import { TermoContribuicaoVoluntaria } from "../shared/models/termoContribuicaoVoluntaria.model";
import { TermoAutoPatrocinioService } from "../shared/services/termoAutoPatrocinio.service";
import { TermoAutoPatrocinio } from "../shared/models/termoAutoPatrocinio.model";
import { TermoResgateService } from "../shared/services/termoResgate.service";
import { TermoResgate } from "../shared/models/termoResgate.model";
import { TermoBpdService } from "../shared/services/termoBpd.service";
import { TermoBpd } from "../shared/models/termoBpd.model";
import { TermoPpe } from "../shared/models/TermoPpe.model";
import { TermoPpeService } from "../shared/services/TermoPpe.service";
import { TermoRequerimentoAposentadoriaService } from "../shared/services/TermoRequerimentoAposentadoria.service";
import { TermoRequerimentoAposentadoria } from "../shared/models/termoRequerimentoAposentadoria.model";
import { WebUploadDocumentosPessoa } from "../shared/models/webUploadDocumentosPessoa.model";
import { WebUploadDocumentosPessoaService } from "../shared/services/webUploadDocumentosPessoa.service";
import { environment } from "environments/environment";
import { Empresa } from "../shared/models/empresa.model";
import { EmpresaService } from "../shared/services/empresa.service";
import { PessoaContaBancaria } from "../shared/models/pessoaContaBancaria.model";
import { PerfilInvestimentoADO } from "../shared/models/perfilInvestimentoADO.model";
import { PerfilInvestimentoADOService } from "../shared/services/perfilInvestimentoADO.service";
import { EstadoCivilService } from "../shared/services/estadoCivil.service";
import { EstadoCivil } from "../shared/models/estadoCivil.model";
import { HistContribuicaoService } from "../shared/services/histContribuicao.service";
import { HistContribuicao } from "../shared/models/histContribuicao.model";
import { Plano } from "../shared/models/plano.model";
import { PlanoService } from "../shared/services/plano.service";
import { WebTempTermoPortabilidadeService } from "../shared/services/webTempTermoPortabilidade.service";
import { WebTempTermoPortabilidade } from "../shared/models/webTempTermoPortabilidade.model";
import { WebLogin } from "../shared/models/WebLogin.model";
import { Esteira } from "../shared/models/esteira.model";
import { WebPlanoAdesaoNovoService } from "../shared/services/webPlanoAdesaoNovo.service";
import { WebTempConvitePlanoFamilia } from "../shared/models/webTempConvitePlanoFamilia.model";
import { Contribuicao } from "../shared/models/contribuicao.model";
import { ContribuicaoService } from "../shared/services/contribuicao.service";
import { TermoTipoRenda } from "../shared/models/TermoTipoRenda.model";
import { WebTempTermoTipoRendaService } from "../shared/services/webTempTermoTipoRenda.service";
import { TermoPerfil } from "../shared/models/TermoPerfil.model";
import { WebTempTermoPerfilService } from "../shared/services/webTempTermoPerfil.service";
import { WebTempTermoAlteracaoPercentualService } from "../shared/services/termoAlteracaoPercentual.service";
import { TermoPercentualContribuicao } from "../shared/models/termoPercentualContribuicao";
import { WebProcessoControleService } from "../shared/services/webProcessoControle.service";
import { TermoREService } from "../shared/services/TermoRE.service";
import { TermoRE } from "../shared/models/termoRE.model";
import { WebDocumentoRestritoService } from "../shared/services/webDocumentosRestrito.service";
import { WebDocumentosRestrito } from "../shared/models/webDocumentosRestrito.model";
import { WebTempTermoAlteracaoResponsavelService } from "../shared/services/TermoAlteracaoResponsavel.service";
import { TermoAlteracaoResponsavel } from "../shared/models/termoAlteracaoResponsavel.model";
import { TermoRgTributarioService } from "../shared/services/TermoRgTributario.service";
import { TermoRgTributario } from "../shared/models/termoRgTributario.model";
import { WebCliente } from "../shared/models/webCliente.model";
import { WebClienteService } from "../shared/services/webCliente.service";
import { ViewModelRetornarQuestionario } from "../shared/models/viewModelRetornarQuestionario.model";
import { RetornarQuestionarioService } from "../shared/services/retornarQuestionario.service";
import { TermoSaqueBeneficio } from "../shared/models/termoSaqueBeneficio.model";
import { TermoSaqueBeneficioService } from "../shared/services/TermoSaqueBeneficio.service";
import { TermoEstadoCivil } from "../shared/models/termoEstadoCivil.model";
import { TermoEstadoCivilService } from "../shared/services/TermoEstadoCivil.service";
import { TermoIsencaoIRService } from "../shared/services/TermoIsencaoIR.service";
import { TermoIsencaoIR } from "../shared/models/termoIsencaoIR.model";
import { TermoPPECompletoService } from "../shared/services/TermoPPECompleto.service";
import { TermoUSPersonService } from "../shared/services/TermoUSPerson.service";
import { TermoContaComplementarService } from "../shared/services/TermoContaComplementar.service";
import { TermoPPECompleto } from "../shared/models/termoPPECompleto.model";
import { TermoUSPerson } from "../shared/models/termoUSPerson.model";
import { TermoContaComplementar } from "../shared/models/termoContaComplementar.model";
import { WebNotificacaoService } from "../shared/services/webNotificacao.service";
import { ViewModelEnviarNotificacaoPessoa } from "../shared/models/viewModelEnviarNotificacaoPessoa.model";
import { HistPlanoParticipanteORMService } from "../shared/services/histPlanoParticipanteORM.service";
import { WebPlanoAdesaoNovo } from "../shared/models/WebPlanoAdesaoNovo.model";
import { WebTempTermoExtratoDesligamento } from "../shared/models/WebTempTermoExtratoDesligamento.model";
import { WebTempTermoExtratoContribAutopatrocinio } from "../shared/models/WebTempTermoExtratoContribAutopatrocinio.model";
import { WebTempTermoExtratoContribAutopatrocinioService } from "../shared/services/WebTempTermoExtratoContribAutopatrocinio.service";
import { WebTempTermoRequerimentoAposentadoria } from "../shared/models/WebTempTermoRequerimentoAposentadoria,model";
import { WebTempTermoRequerimentoAposentadoriaService } from "../shared/services/webTempTermoRequerimentoAposentadoria.service";
import { GetDataValidService } from "../shared/services/getDataValid.service";
import { GetDataValid } from "../shared/models/getDataValid.model";
import { SitucaoDataValid } from "../shared/models/situacaoDataValid.model";
import { Filtro } from "../shared/models/filtro.model";
import { WebPlanoAdesao } from "../shared/models/webPlanoAdesao.model";
import { WebPlanoAdesaoResponse } from "../shared/models/WebPlanoAdesaoResponse.model";
import { ArquivoResponse } from "../shared/models/arquivoResponse.model";
import { UploadDocumentsService } from "../shared/services/uploadDocuments.model";

@Component({
    selector: "app-detalhes",
    templateUrl: "./detalhes.component.html",
    styleUrls: ["./detalhes.component.scss"],
})
export class DetalhesComponent implements OnInit {
    isDateFormat: boolean = environment.isDateFormat;
    webLogin: WebLogin = new WebLogin();
    adesaoSelect: Adesao = new Adesao();
    pessoa: Pessoa = new Pessoa();
    listaStatus: WebStatusRegistro[] = [];
    listaObs: WebStatusObs[] = [];
    listaContribuicao: Contribuicao[] = [];
    listaFinalidade: Finalidade[] = [];
    listaDocumentos: WebRelacaoDocumentos[] = [];
    listaWebHist: WebHistContribuicaoPercentual[] = [];
    dependentes: WebTempDependente[] = [];
    statusRegistro: WebStatusRegistro = new WebStatusRegistro();
    webAlterarCadastroTemp: WebAlterarCadastroTemp =
        new WebAlterarCadastroTemp();
    webHistContribuicaoPercentual: WebHistContribuicaoPercentual =
        new WebHistContribuicaoPercentual();
    webUploadDocumentos: WebUploadDocumentos = new WebUploadDocumentos();
    webHistPlanoParticipante: WebHistPlanoParticipante =
        new WebHistPlanoParticipante();
    webPerfilPlanoParticipante: WebPerfilPlanoParticipante =
        new WebPerfilPlanoParticipante();
    webPlanoParticipante: WebPlanoParticipante = new WebPlanoParticipante();
    planoParticipante: PlanoParticipanteADO = new PlanoParticipanteADO();
    perfilPlanoParticipante: PerfilPlanoParticipante =
        new PerfilPlanoParticipante();
    histPlanoParticipante: HistPlanoParticipante = new HistPlanoParticipante();
    histContribuicaoPercentual: HistContribuicaoPercentual =
        new HistContribuicaoPercentual();
    webTempTermoExtratoBPD: WebTempTermoExtratoBPD =
        new WebTempTermoExtratoBPD();
    webTempTermoRequerimentoAposentadoria: WebTempTermoRequerimentoAposentadoria =
        new WebTempTermoRequerimentoAposentadoria();

    webTempTermoExtratoContribAutopatrocinio: WebTempTermoExtratoContribAutopatrocinio =
        new WebTempTermoExtratoContribAutopatrocinio();
    webTempTermoExtratoDesligamento: WebTempTermoExtratoDesligamento =
        new WebTempTermoExtratoDesligamento();
    autoPatrocinio: AutoPatrocinio = new AutoPatrocinio();
    termoTipoRenda: TermoTipoRenda = new TermoTipoRenda();
    termoPerfil: TermoPerfil = new TermoPerfil();
    pessoaADO: PessoaADO = new PessoaADO();
    dadosBancariosADO: DadosBancariosADO = new DadosBancariosADO();
    dadosBancoADO: DadosBancoADO = new DadosBancoADO();
    webStatusObs: WebStatusObs = new WebStatusObs();
    webInclusaoDependenteTempADO: WebInclusaoDependenteTempADO =
        new WebInclusaoDependenteTempADO();
    webStatusSeguradora: WebStatusSeguradora = new WebStatusSeguradora();
    dependenteFinalidadeADO: DependenteFinalidadeADO =
        new DependenteFinalidadeADO();
    dependenteADO: DependenteADO = new DependenteADO();
    webContratoSeguro: WebContratoSeguro[] = [];
    webContratoSeguroDetalhes: WebContratoSeguro = new WebContratoSeguro();

    webContratoSeguroRespostas: WebContratoSeguroRespostas[] = [];
    listaFluxos: WebEsteiraProcessoFluxo[] = [];
    mensagem: string;
    nmUsuario: string;
    mensagemObs: string;
    dadosCadastrais: boolean = false;
    dadosSeguradora: boolean = false;
    idTermo: number;
    idProcesso: number;
    idPessoa: number = null;
    totalDocs: number = null;
    docs: number = null;
    checado: boolean;
    enc_docs: boolean;
    radioSelect: boolean;
    dependeSeguradora: boolean = false;
    ctbPensao: number = null; // 218
    ctbInvalidez: number = null; // 217
    tabIndex: number = 0;
    dtSolicitacao: Date;
    teste: string;
    nome: string = "";
    nrCpf: string = "";

    private _dataSource = new MatTableDataSource<any>();
    selection = new SelectionModel<Adesao>(true, []);

    textoModalContent: string = "Teste";
    viewModelEnviarNotificacaoPessoa: ViewModelEnviarNotificacaoPessoa =
        new ViewModelEnviarNotificacaoPessoa();

    convite: WebTempConvitePlanoFamilia = new WebTempConvitePlanoFamilia();
    idPessoaResp: number = 0;
    selectedPlano: number;
    selectedProcesso: number;
    selectedSituacao: number;
    dataInicio: Date;
    dataFim: Date;
    termoContribuicaoVoluntaria: TermoContribuicaoVoluntaria =
        new TermoContribuicaoVoluntaria();
    termoAutopatrocinio: TermoAutoPatrocinio = new TermoAutoPatrocinio();
    termoResgate: TermoResgate = new TermoResgate();
    termoAlteracaoPercentual: TermoPercentualContribuicao =
        new TermoPercentualContribuicao();
    termoBpd: TermoBpd = new TermoBpd();
    termoPpe: TermoPpe = new TermoPpe();
    termoAposentadoria: TermoRequerimentoAposentadoria =
        new TermoRequerimentoAposentadoria();
    termoRE: TermoRE = new TermoRE();
    termoAlteracaoResponsavel: TermoAlteracaoResponsavel =
        new TermoAlteracaoResponsavel();
    termoRgTributario: TermoRgTributario = new TermoRgTributario();
    termoSaqueBeneficio: TermoSaqueBeneficio = new TermoSaqueBeneficio();
    termoEstadoCivil: TermoEstadoCivil = new TermoEstadoCivil();
    termoIsencaoIR: TermoIsencaoIR = new TermoIsencaoIR();
    termoPPECompleto: TermoPPECompleto = new TermoPPECompleto();
    termoUSPerson: TermoUSPerson = new TermoUSPerson();
    termoContaComplementar: TermoContaComplementar =
        new TermoContaComplementar();
    webTempTermoExtratoDesligamento2: WebTempTermoExtratoDesligamento = new WebTempTermoExtratoDesligamento();
    termoDependente: WebTempDependente = new WebTempDependente();
    termoPortabilidade: WebTempTermoPortabilidade =
        new WebTempTermoPortabilidade();
    pessoaDependente: Pessoa = new Pessoa();
    listaHist: WebHistContribuicaoPercentual[] = [];
    listaDependentes: WebTempDependente[] = [];
    listaPortabilidade: WebTempTermoPortabilidade[] = [];
    listaCtb: TermoContribuicaoVoluntaria[] = [];
    listaAutopatrocinio: TermoAutoPatrocinio[] = [];
    listaResgate: TermoResgate[] = [];
    listaPerfil: TermoPerfil[] = [];
    listaAlteracaoPercentual: TermoPercentualContribuicao[] = [];
    listaAlteracaoResponsavel: TermoAlteracaoResponsavel[] = [];

    listaTermoContaComplementar: TermoContaComplementar[] = [];
    listaTermoUSPerson: TermoUSPerson[] = [];
    listaTermoPPECompleto: TermoPPECompleto[] = [];
    listaTermoIsencaoIR: TermoIsencaoIR[] = [];
    listaTermoEstadoCivil: TermoEstadoCivil[] = [];
    listaSaqueBeneficio: TermoSaqueBeneficio[] = [];
    listaRgTributario: TermoRgTributario[] = [];
    listaRenda: TermoTipoRenda[] = [];
    listaBpd: TermoBpd[] = [];
    listaPpe: TermoPpe[] = [];
    listaRE: TermoRE[] = [];
    listaAposentadoria: TermoRequerimentoAposentadoria[] = [];
    listaDocs: WebUploadDocumentosPessoa[] = [];
    listaDocs2: WebDocumentosRestrito[] = [];
    listaPlano: Plano[] = [];
    pessoaContaBancaria: PessoaContaBancaria = new PessoaContaBancaria();
    empresa: Empresa = new Empresa();
    planos: PlanoParticipanteADO[] = [];
    perfil: PerfilInvestimentoADO = new PerfilInvestimentoADO();
    listaEstadoCivil: EstadoCivil[] = [];
    ultimaContribuicao: HistContribuicao = new HistContribuicao();
    webPlanoAdesaoNovo: WebPlanoAdesaoNovo = new WebPlanoAdesaoNovo();
    WebPlanoAdesaoResponse: WebPlanoAdesaoResponse = new WebPlanoAdesaoResponse();
    pcContribBasica: number = 0;
    pcContribSuplementar: number = 0;
    listaContribuicoes: WebHistContribuicaoPercentual[] = [];
    addContribuicoes: HistContribuicaoPercentual[] = [];
    podeDeferir: boolean = false;
    webCliente: WebCliente = new WebCliente();
    questionario: ViewModelRetornarQuestionario[] = [];
    nmCategoria: string;
    idcategoria: number;
    idPessoaLogada: number;
    loading = false;
    participanteData: Partial<GetDataValid> | undefined;
    isButtonEnabled: boolean = false;
    isDataDisplay: boolean = false;
    situacaoDataValid: SitucaoDataValid | undefined;
    filtros: any;
    dadosFiltrados: Filtro[] = [];
    arquivosAdesao: ArquivoResponse[] = [];
    constructor(
        public dialog: MatDialog,
        private retonarQuestionarioService: RetornarQuestionarioService,
        private webClienteService: WebClienteService,
        private adesaoService: AdesaoService,
        private finalidadeService: FinalidadeService,
        private contribuicaoService: ContribuicaoService,
        private webStatusObsService: WebStatusObsService,
        private webStatusRegistroService: WebStatusRegistroService,
        private webHistContribuicaoPercentualService: WebHistContribuicaoPercentualService,
        private webRelacaoDocumentosService: WebRelacaoDocumentosService,
        private webTempDependenteService: WebTempDependenteService,
        private webPerfilPlanoParticipanteService: WebPerfilPlanoParticipanteService,
        private webHistPlanoParticipanteService: WebHistPlanoParticipanteService,
        private webPlanoParticipanteService: WebPlanoParticipanteService,
        private planoParticipanteADOService: PlanoParticipanteADOService,
        private histContribuicaoPercentualService: HistContribuicaoPercentualService,
        private dadosBancariosADOService: DadosBancariosADOService,
        private webStatusSeguradoraService: WebStatusSeguradoraService,
        private webContratoSeguroRespostasService: WebContratoSeguroRespostasService,
        private webContratoSeguroService: WebContratoSeguroService,
        private empresaService: EmpresaService,
        private pessoaService: PessoaService,
        private route: ActivatedRoute,
        private location: Location,
        private termoContribuicaoVoluntariaService: TermoContribuicaoVoluntariaService,
        private termoAutopatrocinioService: TermoAutoPatrocinioService,
        private termoResgateService: TermoResgateService,
        private termoBpdService: TermoBpdService,
        private termoPortabilidadeService: WebTempTermoPortabilidadeService,
        private termoPpeService: TermoPpeService,
        private termoAposentadoriaService: TermoRequerimentoAposentadoriaService,
        private termoTipoRendaService: WebTempTermoTipoRendaService,
        public webTempTermoExtratoBPDService: WebTempTermoExtratoBPDService,
        public webTempTermoRequerimentoAposentadoriaService: WebTempTermoRequerimentoAposentadoriaService,
        public webTempTermoExtratoContribAutopatrocinioService: WebTempTermoExtratoContribAutopatrocinioService,
        public webTempTermoExtratoDesligamentoService: WebTempTermoExtratoDesligamentoService,
        private termoPerfilService: WebTempTermoPerfilService,
        private termoAlteracaoPercentualService: WebTempTermoAlteracaoPercentualService,
        private termoAlteracaoResponsavelService: WebTempTermoAlteracaoResponsavelService,
        private termoREService: TermoREService,
        private perfilInvestimentoServiceADO: PerfilInvestimentoADOService,
        private estadoCivilService: EstadoCivilService,
        private histContribuicaoService: HistContribuicaoService,
        private planoService: PlanoService,
        private webPlanoAdesaoNovoService: WebPlanoAdesaoNovoService,
        private webProcessoControleService: WebProcessoControleService,
        private webUploadDocumentosPessoaService: WebUploadDocumentosPessoaService,
        private webDocumentosRestritoService: WebDocumentoRestritoService,
        private termoRgTributarioService: TermoRgTributarioService,
        private termoSaqueBeneficioService: TermoSaqueBeneficioService,
        private termoEstadoCivilService: TermoEstadoCivilService,
        private termoIsencaoIRService: TermoIsencaoIRService,
        private termoPPECompletoService: TermoPPECompletoService,
        private termoUSPersonService: TermoUSPersonService,
        private termoContaComplementarService: TermoContaComplementarService,
        private _snackBar: MatSnackBar,
        private webNotificacaoService: WebNotificacaoService,
        private histPlanoParticipanteORMService: HistPlanoParticipanteORMService,
        private loginStore: LoginStore,
        private planoParticipanteService: PlanoParticipanteService,
        private getDataValidService: GetDataValidService,
        private getSituacaoDataValidService: GetSituacaoDataValidService,
        private uploadDocumentsService: UploadDocumentsService
    ) { }

    ngOnInit() {
        this.loginStore.getCurrent().subscribe((retorno) => {
            this.idPessoaLogada = retorno.idPessoa;
        });

        this.webClienteService.getById(1).subscribe((cliente) => {
            this.webCliente = cliente;
            console.log("cliente", this.webCliente.nmCliente)
        });

        this.adesaoSelect.webEsteiraStatus = new Esteira();

        this.estadoCivilService
            .getAll()
            .subscribe((obj) => (this.listaEstadoCivil = obj));
        this.loadContribuicao();
        this.loadFinalidades();
        //this.loadTotalDocumentos();
        this.loadPlanos();
        //this.carregaDataValid();

        this.route.params.subscribe((obj) => {
            this.selectedProcesso = obj.selectedProcesso
                ? obj.selectedProcesso
                : undefined;
            this.selectedSituacao = obj.selectedSituacao
                ? obj.selectedSituacao
                : undefined;
            this.dataInicio = obj.dataIncio ? obj.dataInicio : undefined;
            this.dataFim = obj.dataFim ? obj.dataFim : undefined;

            this.loadPessoa(obj.nrCpf);

            this.nome = obj.nomePessoa;
            this.nrCpf = obj.nrCpf;
            this.idTermo = obj.id;
            this.idProcesso = obj.idProcesso;
            this.dtSolicitacao = obj.dtSolicitacao;

            console.log("idProcesso:", this.idProcesso);

            if (obj.idProcesso == 1) {
                this.webPlanoAdesaoNovoService.GetByIdAdesao(obj.id).subscribe(
                    (obj) => {
                        this.WebPlanoAdesaoResponse = obj;
                    },
                    (error) => console.log(error)
                );
                //this.loadStatusSeguradora(obj.id);
                this.loadAdesaoData(obj.id);
                this.tabIndex = 0;
            } else if (obj.idProcesso == 2) {
                this.termoAposentadoriaService
                    .getById(obj.id)
                    .subscribe((obj) => {
                        this.termoAposentadoria = obj;
                    });
                this.tabIndex = 2;
            } else if (obj.idProcesso == 3) {
                this.webTempDependenteService
                    .getById(obj.id)
                    .subscribe((dependente) => {
                        this.pessoaService
                            .getById(dependente.idPessoaDep)
                            .subscribe((pessoa) => {
                                dependente.pessoa.nmPessoa = pessoa.nmPessoa;
                                this.termoDependente = dependente;
                            });
                    });
                this.tabIndex = 1;
            } else if (obj.idProcesso == 5) {
                this.termoContribuicaoVoluntariaService
                    .getById(obj.id)
                    .subscribe((obj) => {
                        this.termoContribuicaoVoluntaria = obj;
                    });
                this.tabIndex = 5;
            } else if (obj.idProcesso == 6) {
                this.termoAutopatrocinioService
                    .getById(obj.id)
                    .subscribe((obj) => {
                        this.termoAutopatrocinio = obj;
                    });
                this.tabIndex = 4;
            } else if (obj.idProcesso == 7) {
                this.termoResgateService.getById(obj.id).subscribe((obj) => {
                    this.termoResgate = obj;
                });
                this.tabIndex = 3;
            } else if (obj.idProcesso == 8 || obj.idProcesso == 25) {
                this.termoBpdService.getById(obj.id).subscribe((obj) => {
                    this.termoBpd = obj;
                });
                this.tabIndex = 8;
            } else if (obj.idProcesso == 9) {
                this.termoPortabilidadeService
                    .getById(obj.id)
                    .subscribe((obj) => {
                        this.termoPortabilidade = obj;
                    });
                this.tabIndex = 9;
            } else if (obj.idProcesso == 10) {
                this.webHistContribuicaoPercentualService
                    .getById(obj.id)
                    .subscribe((obj) => {
                        this.webHistContribuicaoPercentual = obj;
                        console.log("IDPROCESSO 10", this.webHistContribuicaoPercentual)
                        console.log("IDstatus", this.webHistContribuicaoPercentual.processo.idProcesso)
                    });
                this.tabIndex = 10;
            } else if (obj.idProcesso == 12) {
                this.termoPpeService.getById(obj.id).subscribe((obj) => {
                    this.termoPpe = obj;
                });
                this.tabIndex = 6;
            } else if (obj.idProcesso == 13) {
                this.termoTipoRendaService.getById(obj.id).subscribe((obj) => {
                    this.termoTipoRenda = obj;
                    this.loadCategoria(
                        this.termoTipoRenda.pessoa.idPessoa,
                        this.termoTipoRenda.plano.idPlano
                    );
                });
                this.tabIndex = 11;
            } else if (obj.idProcesso == 14) {
                this.termoPerfilService.getById(obj.id).subscribe((obj) => {
                    this.termoPerfil = obj;
                });
                this.tabIndex = 12;
            } else if (obj.idProcesso == 15 || obj.idProcesso == 30) {
                this.termoAlteracaoPercentualService
                    .getById(obj.id)
                    .subscribe((obj) => {
                        this.termoAlteracaoPercentual = obj;
                    });
                this.tabIndex = 13;
            } else if (obj.idProcesso == 16) {
                this.termoREService.getById(obj.id).subscribe((obj) => {
                    this.termoRE = obj;
                });
                this.tabIndex = 14;
            } else if (obj.idProcesso == 17) {
                this.termoAlteracaoResponsavelService
                    .getById(obj.id)
                    .subscribe((obj) => {
                        this.termoAlteracaoResponsavel = obj;
                    });
                this.tabIndex = 15;
            } else if (obj.idProcesso == 18) {
                this.termoRgTributarioService
                    .getById(obj.id)
                    .subscribe((obj) => {
                        this.termoRgTributario = obj;
                    });
                this.tabIndex = 16;
            } else if (obj.idProcesso == 19) {
                this.termoSaqueBeneficioService
                    .getById(obj.id)
                    .subscribe((obj) => {
                        this.termoSaqueBeneficio = obj;
                    });
                this.tabIndex = 17;
            } else if (obj.idProcesso == 20) {
                this.termoEstadoCivilService
                    .getById(obj.id)
                    .subscribe((obj) => {
                        this.termoEstadoCivil = obj;
                    });
                this.tabIndex = 18;
            } else if (obj.idProcesso == 21) {
                this.termoIsencaoIRService.getById(obj.id).subscribe((obj) => {
                    this.termoIsencaoIR = obj;
                });
                this.tabIndex = 19;
            } else if (obj.idProcesso == 22) {
                this.termoPPECompletoService
                    .getById(obj.id)
                    .subscribe((obj) => {
                        this.termoPPECompleto = obj;
                    });
                this.tabIndex = 20;
            } else if (obj.idProcesso == 23) {
                this.termoUSPersonService.getById(obj.id).subscribe((obj) => {
                    this.termoUSPerson = obj;
                });
                this.tabIndex = 21;
            } else if (obj.idProcesso == 24) {
                this.termoContaComplementarService
                    .getById(obj.id)
                    .subscribe((obj) => {
                        this.termoContaComplementar = obj;
                    });
                this.tabIndex = 22;
            } else if (obj.idProcesso == 51) {
                this.termoTipoRendaService.getById(obj.id).subscribe((obj) => {
                    this.termoTipoRenda = obj;
                    this.loadCategoria(
                        this.termoTipoRenda.pessoa.idPessoa,
                        this.termoTipoRenda.plano.idPlano
                    );
                });
                this.tabIndex = 11;
            } else if (obj.idProcesso == 53) {
                this.webTempTermoExtratoDesligamentoService
                    .getById(obj.id)
                    .subscribe((obj) => {
                        this.webTempTermoExtratoDesligamento = obj;
                    });
                this.tabIndex = 23;
                this.idTermo = obj.id;
            } else if (obj.idProcesso == 54) {
                this.webTempTermoExtratoContribAutopatrocinioService
                    .getByIdTermoExtratoAutopatrocinio(obj.id)
                    .subscribe((obj) => {
                        //this.webTempTermoExtratoContribAutopatrocinio = obj;
                    });
                this.tabIndex = 24;
                this.idTermo = obj.id;
            } else if (obj.idProcesso == 55) {
                this.webTempTermoExtratoBPDService
                    .getById(obj.id)
                    .subscribe((obj) => {
                        this.webTempTermoExtratoBPD = obj;
                    });
                this.tabIndex = 25;
                this.idTermo = obj.id;
            } else if (obj.idProcesso == 56) {
                this.webTempTermoExtratoDesligamentoService
                    .getById(obj.id)
                    .subscribe((obj) => {
                        this.webTempTermoExtratoDesligamento = obj;
                    });
                this.tabIndex = 26;
                this.idTermo = obj.id;
            } else if (obj.idProcesso == 52) {
                this.webTempTermoRequerimentoAposentadoriaService
                    .getById(obj.id)
                    .subscribe((obj) => {
                        this.webTempTermoRequerimentoAposentadoria = obj;
                        console.log(
                            "beneficio",
                            this.webTempTermoRequerimentoAposentadoria
                        );
                    });
                this.tabIndex = 27;
                this.idTermo = obj.id;
            }
            else if (obj.idProcesso == 57) {

                this.webContratoSeguroService
                    .GetContratosById(obj.id)
                    .subscribe((resp: WebContratoSeguro[]) => {

                        if (resp && resp.length > 0) {
                            this.webContratoSeguroDetalhes = resp[0]; // ✅ AQUI
                            this.handle2(this.webContratoSeguroDetalhes.idContrato);
                        }

                    });


                this.tabIndex = 7;
                this.idTermo = obj.id;
            }

        });

        const search = localStorage.getItem("search");
        const searchData = localStorage.getItem("searchData");

        if (search) {
            this.filtros = JSON.parse(search);
        }

        if (searchData) {
            this.dadosFiltrados = JSON.parse(searchData);
        }

        this.carregaDataValid();
    }

    carregaDataValid() {
        if (this.filtros && this.filtros.cpf) {
            const cpf = this.filtros.cpf;
            this.getDataValidService.getParticipanteData(cpf).subscribe(
                (participanteData) => {
                    this.participanteData = participanteData;

                    this.getSituacaoDataValidService
                        .retornaSituacao(cpf)
                        .subscribe(
                            (data) => {
                                if (data.pontuacao >= 0.85) {
                                    this.situacaoDataValid = data;
                                }
                            },
                            (error) => {
                                console.error(
                                    "Erro ao buscar situação DataValid:",
                                    error
                                );
                            }
                        );
                },
                (error) => {
                    console.error("Erro ao buscar dados DataValid:", error);
                }
            );
        } else {
            console.warn("CPF não encontrado no localStorage");
        }
    }

    // podeDeferirOuIndeferir(): boolean {
    //     return (
    //         this.participanteData &&
    //         this.participanteData.totalAprovacao >= 0.85 &&
    //         this.participanteData.situacao === "APROVADO"
    //     );
    // }

    indeferirDataValid() {
        if (this.participanteData) {
            console.log("Indeferido", this.participanteData);
        }
    }

    deferirDataValid() {
        if (
            this.participanteData &&
            this.participanteData.totalAprovacao >= 0.85
        ) {
            console.log("Solicitação deferida!", this.participanteData);
            this.webProcessoControleService
                .DeferirProcesso({
                    idProcesso: Number(this.idProcesso),
                    idSolicitacao: Number(this.idTermo),
                    idContrato: 0,
                    idPessoaLogin: Number(this.idPessoaLogada),
                })
                .subscribe((obj) =>
                    this.openSnackBar(
                        "O processo foi deferido com sucesso!",
                        "X"
                    )
                );
        }
    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 2000,
            panelClass: ["mat-toolbar", "mat-success"],
        });
    }

    openSnackBarError(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 2000,
            panelClass: ["mat-toolbar", "mat-warn"],
        });
    }

    loadPlanos() {
        this.planoService.getAll().subscribe((obj) => {
            this.listaPlano = obj;
        });
    }

    loadContribuicao() {
        this.contribuicaoService.getAll().subscribe((obj) => {
            this.listaContribuicao = obj;
        });
    }
    loadFinalidades() {
        this.finalidadeService.getAll().subscribe((obj) => {
            this.listaFinalidade = obj;
        });
    }

    loadTotalDocumentos() {
        this.webRelacaoDocumentosService.getAll().subscribe((obj) => {
            this.listaDocumentos = obj;
            this.listaDocumentos.map((obj) => {
                if (obj.icObrigatorio == "S") this.totalDocs++;
            });
        });
    }

    loadStatusSeguradora(id: number) {
        this.webStatusSeguradoraService.getById(id).subscribe((obj) => {
            if (obj) {
                this.webStatusSeguradora = obj;
                this.dadosSeguradora = obj.idStatus == 2 ? true : false;
            }
        });
    }

    loadStatus(nrCpf: string) {
        this.webStatusObsService.getByCpf(nrCpf).subscribe((obj) => {
            this.listaObs = obj;
        });
        this.webStatusRegistroService.getByCpf(nrCpf).subscribe((obj) => {
            this.listaStatus = obj;
        });
    }

    sendEmail() {
        if (!this.pessoa.nmEmail) {
            this.openSnackBarError(
                "O participante não tem um e-mail cadastrado.",
                "X"
            );
            return;
        }

        if (!this.viewModelEnviarNotificacaoPessoa.titulo) {
            this.openSnackBarError("Digite o título do e-mail", "X");
            return;
        }

        if (!this.viewModelEnviarNotificacaoPessoa.mensagem) {
            this.openSnackBarError("Digite a mensagem do e-mail", "X");
            return;
        }

        this.viewModelEnviarNotificacaoPessoa.idPessoa = this.pessoa.idPessoa;
        this.webNotificacaoService
            .enviarNotificacaoPessoa(this.viewModelEnviarNotificacaoPessoa)
            .subscribe(
                (obj) => {
                    this.openSnackBar("Notificação enviada com sucesso!", "X");
                },
                (error) => {
                    this.openSnackBarError(
                        "Erro ao enviar a notificação." + error,
                        "X"
                    );
                }
            );
    }

    indeferirProcesso() {
        this.adesaoSelect.webEsteiraStatus.idStatus = 2;
        this.webProcessoControleService
            .IndeferirProcesso({
                idProcesso: Number(this.idProcesso),
                idSolicitacao: Number(this.idTermo),
                idContrato: 0,
                idPessoaLogin: Number(this.idPessoaLogada),
            })
            .subscribe((obj) =>
                this.openSnackBar("O processo foi indeferido com sucesso!", "X")
            );
    }

    loadAdesaoData(id: number) {
        this.adesaoService.getById(id).subscribe(
            (obj) => {
                this.adesaoSelect = obj;
                this.podeDeferir = true;
                if (
                    this.webCliente &&
                    this.webCliente.nmCliente == "VALUE PREV" &&
                    (this.adesaoSelect.idPlano === 1 || this,
                        this.adesaoSelect.idPlano === 7)
                ) {
                    this.pessoaService
                        .getByCpf(this.adesaoSelect.nrCpf)
                        .subscribe((pessoa) => {
                            this.retonarQuestionarioService
                                .retornar(pessoa.idPessoa)
                                .subscribe((questionario) => {
                                    this.questionario = questionario;
                                    let modal =
                                        document.querySelector("div.modal3");
                                    modal.classList.toggle("hidden");
                                });
                        });
                }
                // this.webTempConvitePlanoFamiliaService.getByCPF(obj.nrCpf).subscribe(convite => {
                //   if (convite != null) {
                //     if (convite.nmPessoaResp != null) {
                //       this.convite = convite
                //       this.pessoaService.getByCpf(convite.nrCpfResp).subscribe(pessoa => {
                //         if (pessoa != null) {
                //           console.log(pessoa)
                //           this.idPessoaResp = pessoa.idPessoa
                //         }
                //       }, error => this.podeDeferir = true)
                //     }
                //   }
                //   this.podeDeferir = true;
                // }, error => this.podeDeferir = true)
            },
            (error) => (this.podeDeferir = true)
        );
    }

    loadPessoaEmpresa(idEmp, idPlano) {
        this.empresaService.getById(idEmp).subscribe((obj) => {
            this.empresa = obj;
            this.perfilInvestimentoServiceADO
                .getPerfilInvestimento(idPlano, obj.idEmp)
                .subscribe((obj) => {
                    this.perfil = obj;
                });
        });
    }
    loadPessoaContribuicao(idPessoa, idPlano) {
        this.histContribuicaoService
            .getUltimaContribuicao(idPessoa, idPlano)
            .subscribe((obj) => {
                this.ultimaContribuicao = obj;
                console.log("contribuicao");
                console.log(obj);
            });
    }

    loadPessoaPercentual(idPessoa, idPlano) {
        this.histContribuicaoPercentualService
            .getByPessoa(idPessoa, idPlano, 1)
            .subscribe((obj) => {
                if (obj) {
                    this.pcContribBasica = obj.pC_CONTRIB;
                }
            });

        this.histContribuicaoPercentualService
            .getByPessoa(idPessoa, idPlano, 3)
            .subscribe((obj) => {
                if (obj) {
                    this.pcContribSuplementar = obj.pC_CONTRIB;
                }
            });
    }
    loadCategoria(idPessoa, idPlano) {
        this.histPlanoParticipanteORMService
            .getCategoria(idPessoa, idPlano)
            .subscribe(
                (categoria) => {
                    if (categoria) {
                        this.idcategoria = categoria.iD_CATEGORIA;
                        this.loadNomeCategoria();
                    }
                },
                (erro) => {
                    console.log(erro, "Erro");
                }
            );
    }

    loadNomeCategoria() {
        this.planoParticipanteService.getCategoria(this.idcategoria).subscribe(
            (retorno) => {
                this.teste = retorno;
                console.log("NOME CATEGORIA ", this.nmCategoria);
            },
            (erro) => {
                console.log(erro, "Erro CATEGORIA");
            }
        );
    }

    loadPessoaPlanos(idPessoa, idEmp) {
        this.planoParticipanteADOService
            .getPlano(idPessoa)
            .subscribe((planos) => {
                this.planos = planos;
                if (planos.length > 0) {
                    this.loadPessoaContribuicao(idPessoa, planos[0].iD_PLANO);
                    this.loadPessoaPercentual(idPessoa, planos[0].iD_PLANO);
                    this.loadPessoaEmpresa(idEmp, planos[0]);
                    //this.loadCategoria(idPessoa, planos[0].iD_PLANO);
                }
            });
    }

    loadPessoaContaBancaria(idPessoa) {
        this.dadosBancariosADOService.getById(idPessoa).subscribe((obj) => {
            if (obj) this.dadosBancariosADO = obj;
        });
    }

    loadAdesaoNovo(idPessoa) {
        this.webPlanoAdesaoNovoService.getByPessoa(idPessoa).subscribe(
            (obj) => {
                this.webPlanoAdesaoNovo = obj;
            },
            (error) => console.log(error)
        );
    }

    loadWebContratoSeguro(idPessoa) {
        this.idPessoa = idPessoa
        this.webContratoSeguroService.getByPessoa(idPessoa).subscribe((obj) => {
            if (obj) {
                this.webContratoSeguro = obj;
                this.handle2(this.webContratoSeguro[0].idContrato);
            }
        });
    }

    loadDocumentos(cpf: string) {
        // 🔹 fluxo antigo – NÃO mexe
        this.webDocumentosRestritoService
            .getBy('C', cpf, 0, 0, 0)
            .subscribe((obj) => {
                this.listaDocs2 = obj || [];
            });

        this.webUploadDocumentosPessoaService.getByCpf(cpf).subscribe(
            (obj) => {
                this.listaDocs = obj || [];
            },
            (error) => console.log(error)
        );

        // 🔹 fluxo novo – ARRAY de ArquivoResponse
        this.uploadDocumentsService.visualizarDocumento(cpf).subscribe(
            (res: ArquivoResponse[]) => {
                console.log('Arquivos de Adesão:', res);
                this.arquivosAdesao = res || [];
            },
            (err) => {
                console.error('Erro ao buscar documentos de adesão', err);
                this.arquivosAdesao = [];
            }
        );
    }

    loadPessoa(cpf) {
        this.loadDocumentos(cpf);
        this.pessoaService.getPessoaMaisAtualByCpf(cpf).subscribe((pessoa) => {
            if (pessoa != null) {
                this.pessoa = pessoa;
                // this.loadWebContratoSeguro(pessoa.idPessoa);
                this.loadPessoaPlanos(pessoa.idPessoa, pessoa.idEmp);
                this.loadPessoaContaBancaria(pessoa.idPessoa);
                this.loadAdesaoNovo(pessoa.idPessoa);
                //this.loadPessoaPlanoTemp(pessoa.idPessoa)
            }
        });
    }

    changeTab(event: MatTabChangeEvent) {
        this.loading = true;
        switch (event.index) {
            case 10:
                this.webHistContribuicaoPercentualService
                    .getByCpf(this.pessoa.nrCnpjCpf)
                    .subscribe(
                        (obj) => {
                            this.listaHist = obj;
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                        }
                    );
                break;
            case 5:
                this.termoContribuicaoVoluntariaService
                    .getByCpf(this.pessoa.nrCnpjCpf)
                    .subscribe(
                        (obj) => {
                            this.listaCtb = obj;
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                        }
                    );
                break;
            case 4:
                this.termoAutopatrocinioService
                    .getByCpf(this.pessoa.nrCnpjCpf)
                    .subscribe(
                        (obj) => {
                            this.listaAutopatrocinio = obj;
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                        }
                    );
                break;
            case 3:
                this.termoResgateService
                    .getByCpf(this.pessoa.nrCnpjCpf)
                    .subscribe(
                        (obj) => {
                            this.listaResgate = obj;
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                        }
                    );
                break;
            case 8:
                this.termoBpdService.getByCpf(this.pessoa.nrCnpjCpf).subscribe(
                    (obj) => {
                        this.listaBpd = obj;
                        this.loading = false;
                    },
                    (error) => {
                        this.loading = false;
                    }
                );
                break;
            case 6:
                this.termoPpeService.getByCpf(this.pessoa.nrCnpjCpf).subscribe(
                    (obj) => {
                        this.listaPpe = obj;
                        this.loading = false;
                    },
                    (error) => {
                        this.loading = false;
                    }
                );
                break;
            case 2:
                this.termoAposentadoriaService
                    .getByCpf(this.pessoa.nrCnpjCpf)
                    .subscribe(
                        (obj) => {
                            this.listaAposentadoria = obj;
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                        }
                    );
                break;
            case 11:
                this.termoTipoRendaService
                    .getByCpf(this.pessoa.nrCnpjCpf)
                    .subscribe(
                        (obj) => {
                            this.listaRenda = obj;
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                        }
                    );
                break;
            case 12:
                this.termoPerfilService
                    .getByCpf(this.pessoa.nrCnpjCpf)
                    .subscribe(
                        (obj) => {
                            this.listaPerfil = obj;
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                        }
                    );
                break;
            case 13:
                this.termoAlteracaoPercentualService
                    .getByCpf(this.pessoa.nrCnpjCpf)
                    .subscribe(
                        (obj) => {
                            this.listaAlteracaoPercentual = obj;
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                        }
                    );
                break;
            case 17:
                this.termoAlteracaoResponsavelService
                    .getByCpf(this.pessoa.nrCnpjCpf)
                    .subscribe(
                        (obj) => {
                            this.listaAlteracaoResponsavel = obj;
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                        }
                    );
                break;
            case 18:
                this.termoRgTributarioService
                    .getByCpf(this.pessoa.nrCnpjCpf)
                    .subscribe(
                        (obj) => {
                            this.listaRgTributario = obj;
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                        }
                    );
                break;
            case 19:
                this.termoSaqueBeneficioService
                    .getByCpf(this.pessoa.nrCnpjCpf)
                    .subscribe(
                        (obj) => {
                            this.listaSaqueBeneficio = obj;
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                        }
                    );
                break;
            case 20:
                this.termoEstadoCivilService
                    .getByCpf(this.pessoa.nrCnpjCpf)
                    .subscribe(
                        (obj) => {
                            this.listaTermoEstadoCivil = obj;
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                        }
                    );
                break;
            case 21:
                this.termoIsencaoIRService
                    .getByCpf(this.pessoa.nrCnpjCpf)
                    .subscribe(
                        (obj) => {
                            this.listaTermoIsencaoIR = obj;
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                        }
                    );
                break;
            case 22:
                this.termoPPECompletoService
                    .getByCpf(this.pessoa.nrCnpjCpf)
                    .subscribe(
                        (obj) => {
                            this.listaTermoPPECompleto = obj;
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                        }
                    );
                break;
            case 23:
                this.termoUSPersonService
                    .getByCpf(this.pessoa.nrCnpjCpf)
                    .subscribe(
                        (obj) => {
                            this.listaTermoUSPerson = obj;
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                        }
                    );
                break;
            case 24:
                this.termoContaComplementarService
                    .getByCpf(this.pessoa.nrCnpjCpf)
                    .subscribe(
                        (obj) => {
                            this.listaTermoContaComplementar = obj;
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                        }
                    );
                break;
            case 1:
                this.webTempDependenteService
                    .getByCpf(this.pessoa.nrCnpjCpf)
                    .subscribe(
                        (obj) => {
                            this.listaDependentes = obj;
                            this.listaDependentes.map((dependente) => {
                                this.pessoaService
                                    .getById(dependente.idPessoaDep)
                                    .subscribe((obj) => {
                                        dependente.pessoa.nmPessoa =
                                            obj.nmPessoa;
                                    });
                            });
                            this.loading = false;
                        },
                        (error) => {
                            this.loading = false;
                        }
                    );
                break;
        }
        this.loading = false;
    }

    getContribuicao(idContribuicao) {
        return this.listaContribuicao.find(
            (x) => x.idContribuicao == idContribuicao
        ).nmContribuicao;
    }

    // verPDF(){

    //     const linkSource = this.webTempTermoExtratoDesligamento.NmCodExtratoPrevidenciario;
    //     const linkSource2 = this.webTempTermoExtratoDesligamento.NmCodTermoOpcao;
    //     const linkSource3 = this.webTempTermoExtratoDesligamento.NmCodDemonstrativoResgate;
    //     const linkSource4 = this.webTempTermoExtratoDesligamento.NmCodTermoPortabilidade;
    //     if (linkSource !== null) {
    //         var blob = this.b64toBlob(linkSource, "application/pdf");
    //         let a = document.createElement("a");
    //         document.body.appendChild(a);
    //         var url = window.URL.createObjectURL(blob);
    //         a.href = url;
    //         a.download = String("contrato" + this.webTempTermoExtratoDesligamento.pessoa.nrCnpjCpf + ".pdf");

    //         a.click();
    //         window.URL.revokeObjectURL(url);
    //         a.remove();

    //     }
    // }
    verPDF() {
        if (this.idProcesso == 53) {
            //resgate
            this.loading = true;
            this.webTempTermoExtratoDesligamentoService
                .getById(this.idTermo)
                .subscribe(
                    (retorno) => {
                        console.log("PDF", retorno["data"]);
                        if (retorno) {
                            if (
                                retorno.nmCodExtratoPrevidenciario === null ||
                                retorno.nmCodExtratoPrevidenciario ===
                                undefined ||
                                retorno.nmCodTermoOpcao === null ||
                                retorno.nmCodTermoOpcao === undefined ||
                                retorno.nmCodDemonstrativoResgate === null ||
                                retorno.nmCodDemonstrativoResgate === undefined
                            ) {
                                this.openSnackBar(
                                    "O participante não tem contrato assinado!",
                                    "X"
                                );
                                this.loading = false;
                            }
                            if (retorno) {
                                console.log("entrou");
                                console.log(
                                    "PDF",
                                    retorno.nmCodExtratoPrevidenciario
                                );
                                //extrato previdenciario
                                var blob = this.b64toBlob1(
                                    retorno.nmCodExtratoPrevidenciario,
                                    "application/pdf"
                                );
                                let a = document.createElement("a");
                                document.body.appendChild(a);
                                var url = window.URL.createObjectURL(blob);
                                a.href = url;
                                a.download = String(
                                    "extrato-previdenciario" +
                                    this.nrCpf +
                                    ".pdf"
                                );

                                a.click();
                                window.URL.revokeObjectURL(url);
                                a.remove();

                                //termo opção
                                var blob = this.b64toBlob2(
                                    retorno.nmCodTermoOpcao,
                                    "application/pdf"
                                );
                                let b = document.createElement("b");
                                document.body.appendChild(b);
                                var url = window.URL.createObjectURL(blob);
                                a.href = url;
                                a.download = String(
                                    "termo-opcao" + this.nrCpf + ".pdf"
                                );

                                a.click();
                                window.URL.revokeObjectURL(url);
                                a.remove();

                                //Demostrativo Resgate
                                var blob = this.b64toBlob3(
                                    retorno.nmCodDemonstrativoResgate,
                                    "application/pdf"
                                );
                                let c = document.createElement("c");
                                document.body.appendChild(c);
                                var url = window.URL.createObjectURL(blob);
                                a.href = url;
                                a.download = String(
                                    "demostrativo-resgate" + this.nrCpf + ".pdf"
                                );

                                a.click();
                                window.URL.revokeObjectURL(url);
                                a.remove();
                                this.loading = false;
                            }
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.openSnackBarError(
                            "Erro ao buscar o contrato!" + error,
                            "X"
                        );
                    }
                );
        }
        if (this.idProcesso == 56) {
            //portabilidade
            this.loading = true;
            this.webTempTermoExtratoDesligamentoService
                .getById(this.idTermo)
                .subscribe(
                    (retorno) => {
                        if (retorno) {
                            if (
                                retorno.nmCodExtratoPrevidenciario === null ||
                                retorno.nmCodExtratoPrevidenciario ===
                                undefined ||
                                retorno.nmCodTermoOpcao === null ||
                                retorno.nmCodTermoOpcao === undefined ||
                                retorno.nmCodTermoPortabilidade === null ||
                                retorno.nmCodTermoPortabilidade === undefined
                            ) {
                                this.openSnackBar(
                                    "O participante não tem contrato assinado!",
                                    "X"
                                );
                                this.loading = false;
                            } else {
                                console.log("entrou");
                                console.log(
                                    "PDF",
                                    retorno.nmCodExtratoPrevidenciario
                                );
                                //extrato previdenciario
                                var blob = this.b64toBlob1(
                                    retorno.nmCodExtratoPrevidenciario,
                                    "application/pdf"
                                );
                                let a = document.createElement("a");
                                document.body.appendChild(a);
                                var url = window.URL.createObjectURL(blob);
                                a.href = url;
                                a.download = String(
                                    "extrato-previdenciario" +
                                    this.nrCpf +
                                    ".pdf"
                                );

                                a.click();
                                window.URL.revokeObjectURL(url);
                                a.remove();

                                //termo opção
                                var blob = this.b64toBlob2(
                                    retorno.nmCodTermoOpcao,
                                    "application/pdf"
                                );
                                let b = document.createElement("b");
                                document.body.appendChild(b);
                                var url = window.URL.createObjectURL(blob);
                                a.href = url;
                                a.download = String(
                                    "termo-opcao" + this.nrCpf + ".pdf"
                                );

                                a.click();
                                window.URL.revokeObjectURL(url);
                                a.remove();

                                //Termo Portabilidade
                                var blob = this.b64toBlob4(
                                    retorno.nmCodTermoPortabilidade,
                                    "application/pdf"
                                );
                                let d = document.createElement("d");
                                document.body.appendChild(d);
                                var url = window.URL.createObjectURL(blob);
                                a.href = url;
                                a.download = String(
                                    "termo-portabilidade" + this.nrCpf + ".pdf"
                                );

                                a.click();
                                window.URL.revokeObjectURL(url);
                                a.remove();
                                this.loading = false;
                            }
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.openSnackBarError(
                            "Erro ao buscar o contrato!" + error,
                            "X"
                        );
                    }
                );
        }
        if (this.idProcesso == 54) {
            //Autopatrocinio
            this.loading = true;
            this.webTempTermoExtratoContribAutopatrocinioService
                .getById(this.idTermo)
                .subscribe(
                    (retorno) => {
                        if (retorno) {
                            if (
                                retorno.nmCodExtratoPrevidenciario === null ||
                                retorno.nmCodExtratoPrevidenciario ===
                                undefined ||
                                retorno.nmCodTermoOpcao === null ||
                                retorno.nmCodTermoOpcao === undefined
                            ) {
                                this.openSnackBar(
                                    "O participante não tem contrato assinado!",
                                    "X"
                                );
                                this.loading = false;
                            } else {
                                console.log("entrou");
                                console.log(
                                    "PDF",
                                    retorno.nmCodExtratoPrevidenciario
                                );
                                //extrato previdenciario
                                var blob = this.b64toBlob1(
                                    retorno.nmCodExtratoPrevidenciario,
                                    "application/pdf"
                                );
                                let a = document.createElement("a");
                                document.body.appendChild(a);
                                var url = window.URL.createObjectURL(blob);
                                a.href = url;
                                a.download = String(
                                    "extrato-previdenciario" +
                                    this.nrCpf +
                                    ".pdf"
                                );

                                a.click();
                                window.URL.revokeObjectURL(url);
                                a.remove();

                                //termo opção
                                var blob = this.b64toBlob2(
                                    retorno.nmCodTermoOpcao,
                                    "application/pdf"
                                );
                                let b = document.createElement("b");
                                document.body.appendChild(b);
                                var url = window.URL.createObjectURL(blob);
                                a.href = url;
                                a.download = String(
                                    "termo-opcao" + this.nrCpf + ".pdf"
                                );

                                a.click();
                                window.URL.revokeObjectURL(url);
                                a.remove();

                                this.loading = false;
                            }
                        }
                    },
                    (error) => {
                        this.loading = false;
                        this.openSnackBarError(
                            "Erro ao buscar o contrato!" + error,
                            "X"
                        );
                    }
                );
        }
        if (this.idProcesso == 55) {
            //BPD
            this.loading = true;
            this.webTempTermoExtratoBPDService.getById(this.idTermo).subscribe(
                (retorno) => {
                    if (retorno) {
                        if (
                            retorno.nmCodExtratoPrevidenciario === null ||
                            retorno.nmCodExtratoPrevidenciario === undefined ||
                            retorno.nmCodTermoOpcao === null ||
                            retorno.nmCodTermoOpcao === undefined
                        ) {
                            this.openSnackBar(
                                "O participante não tem contrato assinado!",
                                "X"
                            );
                            this.loading = false;
                        } else {
                            console.log("entrou");
                            console.log(
                                "PDF",
                                retorno.nmCodExtratoPrevidenciario
                            );
                            //extrato previdenciario
                            var blob = this.b64toBlob1(
                                retorno.nmCodExtratoPrevidenciario,
                                "application/pdf"
                            );
                            let a = document.createElement("a");
                            document.body.appendChild(a);
                            var url = window.URL.createObjectURL(blob);
                            a.href = url;
                            a.download = String(
                                "extrato-previdenciario" + this.nrCpf + ".pdf"
                            );

                            a.click();
                            window.URL.revokeObjectURL(url);
                            a.remove();

                            //termo opção
                            var blob = this.b64toBlob2(
                                retorno.nmCodTermoOpcao,
                                "application/pdf"
                            );
                            let b = document.createElement("b");
                            document.body.appendChild(b);
                            var url = window.URL.createObjectURL(blob);
                            a.href = url;
                            a.download = String(
                                "termo-opcao" + this.nrCpf + ".pdf"
                            );

                            a.click();
                            window.URL.revokeObjectURL(url);
                            a.remove();

                            this.loading = false;
                        }
                    }
                },
                (error) => {
                    this.loading = false;
                    this.openSnackBarError(
                        "Erro ao buscar o contrato!" + error,
                        "X"
                    );
                }
            );
        }
    }

    ngAfterViewInit() {
        // inicia quando a view do component é carregado
    }

    getFinalidade(idFinalidade: number) {
        const finalidade = this.listaFinalidade.find(
            (x) => x.idFinalidade == idFinalidade
        );

        if (!finalidade) return "";

        return finalidade.nmFinalidade;
    }

    showModal() {
        let modal = document.querySelector("div.modal4");
        modal.classList.toggle("hidden");
    }

    showModal2() {
        this.viewModelEnviarNotificacaoPessoa =
            new ViewModelEnviarNotificacaoPessoa();
        let modal = document.querySelector("div.modal5");
        modal.classList.toggle("hidden");
    }

    handle2(index: Number) {
        this.webContratoSeguroRespostasService
            .getByContrato(index)
            .subscribe((obj) => {
                if (obj) this.webContratoSeguroRespostas = obj;
            });
        let modal = document.querySelector("div.modal3");
        modal.classList.toggle("hidden");
    }

    handle(index: number) {
        if (index != null) {
            this.nmUsuario = this.listaObs[index].nmUsuario;
            this.mensagemObs = this.listaObs[index].mensagem;
        }
        let modal = document.querySelector("div.modal3");
        modal.classList.toggle("hidden");
    }

    handleDocLoad() {
        let modal = document.querySelector("div.modal");
        modal.classList.toggle("hidden");
    }

    handleDescriptionModal() {
        let modal = document.querySelector("div#description-modal");
        modal.classList.toggle("hidden");
    }

    handleObsLoad() {
        let modal = document.querySelector("div.modal");
        modal.classList.toggle("hidden");
    }

    handleGoBack() {
        this.location.back();
    }

    getPlano(idPlano: number) {
        const plano = this.listaPlano.find((x) => x.idPlano == idPlano);
        return plano ? plano.nmPlano : "";
    }

    getSituacao(idStatus: Number) {
        switch (idStatus) {
            case 1:
                return "DEFERIDO";
                break;
            case 2:
                return "INDEFERIDO";
                break;
        }
    }

    getSituacao2(idStatus: number) {
        switch (idStatus) {
            case 1:
                return "DEFERIDO";
                break;
            case 2:
                return "INDEFERIDO";
                break;
            case 3:
                return "PENDENTE";
                break;
            case 4:
                return "CANCELADO";
                break;
        }
    }

    alterarDesc() {
        this.webStatusObs.nrCpf = this.adesaoSelect.nrCpf;
        this.webStatusObs.nmUsuario = "TRUST";
        this.webStatusObs.mensagem = this.mensagem;
        this.webStatusObs.dtObs = new Date();
        this.webStatusObsService.Post(this.webStatusObs).subscribe((obs) => {
            this.webStatusObsService
                .getByCpf(this.adesaoSelect.nrCpf)
                .subscribe((obj) => {
                    this.listaObs = obj;
                });
        });
    }

    getAge(dateString) {
        var today = new Date();
        var birthDate = new Date(dateString);
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    deferirSolicitacao(contrato: WebContratoSeguro) {
        contrato.idStatus = 1;
        this.webContratoSeguroService.Put(contrato).subscribe(
            (obj) => {
                console.log(obj);
            },
            (error) => {
                console.log(error);
            }
        );
    }

    // deferirDependente(dependente: WebTempDependente) {
    //   if (dependente.webEsteiraStatus.idStatus == 3) {

    //     let age = this.getAge(
    //       this.pessoa.dtNascimento.toString().slice(6, 10) + "-" +
    //       this.pessoa.dtNascimento.toString().slice(3, 5) + "-" +
    //       this.pessoa.dtNascimento.toString().slice(0, 2),
    //     );
    //     dependente.webEsteiraStatus.idStatus = 1;
    //     dependente.webEsteiraStatus.nmStatus = "DEFERIDO";
    //     this.webInclusaoDependenteTempADO.iD_PESSOA = this.pessoa.idPessoa;
    //     this.webInclusaoDependenteTempADO.iD_PESSOA_DEP =
    //       dependente.idPessoaDep;
    //     this.webInclusaoDependenteTempADO.iD_STATUS = 1;
    //     this.webTempDependenteService.Put(this.webInclusaoDependenteTempADO)
    //       .subscribe((obj) => {
    //         console.log(obj);
    //       });

    //     this.dependenteADO.iD_PESSOA = this.pessoa.idPessoa;
    //     this.dependenteADO.iD_PESSOA_DEP = dependente.idPessoaDep;
    //     this.dependenteADO.iD_PARENTESCO = dependente.idParentesco;
    //     this.dependenteADO.iC_INVALIDO = dependente.icInvalido;
    //     this.dependenteADO.iC_SUPERIOR = age >= 21 ? "S" : "N";
    //     this.dependenteADO
    //     console.log('depedenteAdo');
    //     console.log(this.dependenteADO)
    //     this.dependenteADOService.Post(this.dependenteADO).subscribe((obj) =>
    //       console.log(obj)
    //       , error => console.log(error));

    //     this.dependenteFinalidadeADO.iD_PESSOA = this.pessoa.idPessoa;
    //     this.dependenteFinalidadeADO.iD_PESSOA_DEP = dependente.idPessoaDep;
    //     this.dependenteFinalidadeADO.iD_FINALIDADE = dependente.idFinalidade;
    //     this.dependenteFinalidadeADO.dT_INI = new Date();
    //     this.dependenteFinalidadeADO.pC_RATEIO = dependente.participacao;
    //     console.log('RATEIO');
    //     console.log(dependente.participacao)
    //     console.log(this.dependenteFinalidadeADO)
    //     this.dependenteFinalidadeADOService.Post(this.dependenteFinalidadeADO)
    //       .subscribe((obj) => console.log(obj), error => console.log(error));

    //   }
    // }

    // indeferirDependente(dependente: WebTempDependente) {
    //   if (dependente.webEsteiraStatus.idStatus == 3) {
    //     dependente.webEsteiraStatus.idStatus = 2;
    //     dependente.webEsteiraStatus.nmStatus = "INDEFERIDO";
    //     this.webInclusaoDependenteTempADO.iD_PESSOA = this.idPessoa;
    //     this.webInclusaoDependenteTempADO.iD_PESSOA_DEP = dependente.idPessoaDep;
    //     this.webInclusaoDependenteTempADO.iD_STATUS = 2;
    //     this.webTempDependenteService.Put(this.webInclusaoDependenteTempADO)
    //       .subscribe((obj) => {
    //         console.log(obj);
    //       });
    //   }
    // }

    // atualizarAdesao() {
    //   console.log('atualizou aqui')
    //   this.adesaoSelect.icPrimeiroAcesso = "N";
    //   this.adesaoSelect.webEsteiraStatus.idStatus = 1;
    //   this.adesaoSelect.webEsteiraStatus.nmStatus = "DEFERIMENTO";
    //   this.adesaoService.PutStatus([this.adesaoSelect]).subscribe();

    //   console.log('tentou atualizar aqui')
    //   this.webPlanoParticipante.idPlano = this.adesaoSelect.idPlano;
    //   this.webPlanoParticipante.webEsteiraStatus = new Esteira();
    //   this.webPlanoParticipante.webEsteiraStatus.idStatus = 1;
    //   this.webPlanoParticipante.webEsteiraStatus.nmStatus = "DEFERIMENTO";
    //   console.log('passou por aqui 101')
    //   this.webPlanoParticipanteService.Put(this.webPlanoParticipante).subscribe(obj => {
    //     console.log('deferiu aqui')
    //     console.log(obj)
    //   }, error => { console.log('ta com erro aqui'); console.log(error) });

    // }

    // postLogin() {
    //   console.log('passou aqui 3')
    //   this.webLogin.nmNome = this.pessoa.nmPessoa;
    //   this.webLogin.nmEmail = this.pessoa.nmEmail;
    //   this.webLogin.idPessoa = this.pessoa.idPessoa;
    //   this.webLogin.nrCpf = this.pessoa.nrCnpjCpf;
    //   this.webLogin.idCliente = 1;
    //   this.webLogin.nmSenha = Math.random().toString(36).substring(0, 10);
    //   this.webLogin.dtAlteracao = new Date();
    //   this.webLogin.dtCriacao = new Date();
    //   this.webLogin.icAtivo = "S";
    //   console.log('passou aqui 4')
    //   console.log(this.webLogin)
    //   this.webLoginService.createLogin(this.webLogin).subscribe(login => { console.log('retornou login'); console.log(login) }, error => { console.log('passou no erro'); console.log(error) });
    // }

    // gerarAcesso() {
    //   console.log(this.pessoa)
    //   console.log('passou aqui')
    //   if (this.pessoa.nrMatricula == undefined) {
    //     this.pessoaADO.iD_PESSOA = this.pessoa.idPessoa
    //     this.pessoaADOService.GerarInscricao(this.pessoaADO).subscribe(pessoa => {
    //       console.log('passo aqui 2')
    //       this.postLogin()
    //     })
    //   } else {
    //     console.log('passou aqui 3')
    //     this.postLogin()
    //   }
    // }

    // postHistPlanoParticipante() {
    //   this.histPlanoParticipante.iD_PESSOA = this.pessoa.idPessoa;
    //   this.histPlanoParticipante.iD_PLANO = this.adesaoSelect.idPlano;
    //   this.histPlanoParticipante.dT_INI = new Date();
    //   this.histPlanoParticipante.iD_CATEGORIA = 1;
    //   this.histPlanoParticipante.iD_SITUACAO = 1;
    //   this.histPlanoParticipanteService.Post(this.histPlanoParticipante)
    //     .subscribe(obj => { console.log(obj) }, error => console.log(error));
    // }

    // postPerfilPlanoParticipante() {
    //   console.log('perfil')
    //   this.webPerfilPlanoParticipante.webEsteiraStatus = new Esteira();
    //   this.webPerfilPlanoParticipante.webEsteiraStatus.idStatus = 1;
    //   this.webPerfilPlanoParticipanteService.Put(this.webPerfilPlanoParticipante);

    //   this.perfilPlanoParticipante.iD_PESSOA = this.webPerfilPlanoParticipante.idPessoa;
    //   this.perfilPlanoParticipante.iD_PLANO = this.webPerfilPlanoParticipante.idPlano;
    //   this.perfilPlanoParticipante.iD_PERFIL = this.webPerfilPlanoParticipante.idPerfil;
    //   this.perfilPlanoParticipante.dT_VIGENCIA = this.webPerfilPlanoParticipante.dtVigencia;
    //   console.log(this.perfilPlanoParticipante);
    //   this.perfilPlanoParticipanteService.Post(this.perfilPlanoParticipante)
    //     .subscribe(obj => { console.log(obj) }, error => console.log(error));
    // }

    // postHistContribuicaoPercentual() {

    //   this.addContribuicoes = [];

    //   this.listaContribuicoes.map(contribuicao => {
    //     var contrib = new HistContribuicaoPercentual();
    //     contribuicao.status.idStatus = 1;
    //     this.webHistContribuicaoPercentualService.Put(contribuicao);

    //     contrib.iD_PESSOA = contribuicao.pessoa.idPessoa;
    //     contrib.iD_CONTRIBUICAO = contribuicao.iD_CONTRIBUICAO;
    //     contrib.iD_PLANO = contribuicao.plano.idPlano;
    //     contrib.pC_CONTRIB = contribuicao.pC_CONTRIB;
    //     contrib.dT_VIGENCIA = contribuicao.dT_VIGENCIA;
    //     contrib.IC_OPTANTE = contribuicao.iC_OPTANTE;
    //     contrib.QT_PARCELAS = contribuicao.qT_PARCELAS;
    //     contrib.QT_TETO = contribuicao.qT_TETO;
    //     contrib.QT_AJUSTE_PAGAS = contribuicao.qT_AJUSTES_PAGAS;
    //     contrib.IC_SUSPENSAO = contribuicao.iC_SUSPENSAO;

    //     console.log(contrib);

    //     this.addContribuicoes.push(contrib)

    //     this.postAutopatrocinio(contribuicao.iD_CONTRIBUICAO)

    //   });

    //   console.log('novas contribuicoes');
    //   console.log(this.addContribuicoes);

    //   this.histContribuicaoPercentualService.CriarList(this.addContribuicoes).subscribe(obj => console.log(obj), error => console.log(error))
    // }

    // postAutopatrocinio(idContrib) {
    //   this.autoPatrocinio.iD_PESSOA = this.pessoa.idPessoa;
    //   this.autoPatrocinio.iD_PLANO = this.adesaoSelect.idPlano;
    //   this.autoPatrocinio.iD_CONTRIBUICAO = idContrib;
    //   this.autoPatrocinio.iD_MODO_PAG_REC = this.webPlanoParticipante.idModoPagRec;
    //   this.autoPatrocinio.iC_COBRA = "S";
    //   this.autoPatrocinio.iC_RESP_FINANC = this.idPessoaResp > 0 ? "S" : "N";
    //   this.autoPatrocinioService.Post(this.autoPatrocinio).subscribe(obj => console.log(obj))
    // }

    // postDependente() {
    //   console.log(this.listaDependentes)
    //   this.listaDependentes.map(dependente => {
    //     console.log(dependente)
    //     this.deferirDependente(dependente);
    //   })
    // }

    // postPlanoParticipante() {
    //   console.log('plano participante')
    //   this.planoParticipante.iD_PESSOA = this.pessoa.idPessoa;
    //   this.planoParticipante.iD_PLANO = this.adesaoSelect.idPlano;
    //   this.planoParticipante.dT_INI_PLANO = this.webPlanoParticipante.dtIniPlano;
    //   this.planoParticipante.dT_INI_AUTO = this.webPlanoParticipante.dtIniPlano;
    //   this.planoParticipante.iC_PARCIAL = 'N';
    //   this.planoParticipante.iC_TRIBUTACAO =
    //     this.webPlanoParticipante.icTributacao;
    //   this.planoParticipante.iC_CALCULO_AUTO = 'N';
    //   this.planoParticipante.iD_MODO_PAG_REC =
    //     this.webPlanoParticipante.idModoPagRec;
    //   this.planoParticipante.nR_VENCIMENTO = this.webPlanoParticipante.nrVencimento;
    //   this.planoParticipante.dT_INI_PLANO = this.webPlanoParticipante.dtIniPlano;
    //   if (this.idPessoaResp > 0)
    //     this.planoParticipante.iD_PESSOA_RESP = this.idPessoaResp;
    //   this.planoParticipanteService.Post(this.planoParticipante).subscribe(
    //     (obj) => {

    //       console.log('voltou obj')
    //       console.log(obj)

    //       this.postHistPlanoParticipante()

    //       this.postPerfilPlanoParticipante()

    //       this.postHistContribuicaoPercentual()

    //       this.postDependente();

    //       this.envioEmailAdesaoService.enviarEmailAdesao(this.pessoa.idPessoa);

    //     }, error => console.log(error));
    // }

    // deferir() {

    //   console.log(this.webPlanoParticipante);

    //   if (this.webPlanoParticipante.idPessoa > 0 && this.pessoa != null && this.podeDeferir) {

    //     console.log('log 1')

    //     this.atualizarAdesao()

    //     this.gerarAcesso()

    //     this.postPlanoParticipante()

    //     this.ModalController("A Solicitação foi DEFERIDA");

    //   }
    // }
    showPdf(idTermo: number) {
        this.loading = true;
        this.termoTipoRendaService.getTermoByPessoa(idTermo).subscribe(
            (retorno) => {
                if (retorno) {
                    if (retorno.nmContratoAssinado === null) {
                        this.openSnackBar(
                            "O participante não tem contrato assinado!",
                            "X"
                        );
                        this.loading = false;
                    } else {
                        var blob = this.b64toBlob(
                            retorno.nmContratoAssinado,
                            "application/pdf"
                        );
                        let a = document.createElement("a");
                        document.body.appendChild(a);
                        var url = window.URL.createObjectURL(blob);
                        a.href = url;
                        a.download = String("contrato" + this.nrCpf + ".pdf");

                        a.click();
                        window.URL.revokeObjectURL(url);
                        a.remove();
                        this.loading = false;
                    }
                }
            },
            (error) => {
                this.loading = false;
                this.openSnackBarError(
                    "Erro ao buscar o contrato!" + error,
                    "X"
                );
            }
        );
    }
    public b64toBlob(b64Data, contentType) {
        contentType = contentType || "";
        let sliceSize = 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (
            var offset = 0;
            offset < byteCharacters.length;
            offset += sliceSize
        ) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
    public b64toBlob1(b64Data, contentType) {
        contentType = contentType || "";
        let sliceSize = 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (
            var offset = 0;
            offset < byteCharacters.length;
            offset += sliceSize
        ) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
    public b64toBlob2(b64Data, contentType) {
        contentType = contentType || "";
        let sliceSize = 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (
            var offset = 0;
            offset < byteCharacters.length;
            offset += sliceSize
        ) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
    public b64toBlob3(b64Data, contentType) {
        contentType = contentType || "";
        let sliceSize = 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (
            var offset = 0;
            offset < byteCharacters.length;
            offset += sliceSize
        ) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
    public b64toBlob4(b64Data, contentType) {
        contentType = contentType || "";
        let sliceSize = 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (
            var offset = 0;
            offset < byteCharacters.length;
            offset += sliceSize
        ) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);

            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            var byteArray = new Uint8Array(byteNumbers);

            byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
    processoAcao(idSolicitacao, idProcesso, element, idStatus) {
        switch (idStatus) {
            case 1:
                this.webProcessoControleService
                    .DeferirProcesso({
                        idProcesso: idProcesso,
                        idSolicitacao: idSolicitacao,
                        idContrato: 0,
                        idPessoaLogin: Number(this.idPessoaLogada),
                    })
                    .subscribe(
                        (obj) => {
                            this.openSnackBar(
                                "Processo deferido com sucesso!",
                                "X"
                            );
                            switch (idProcesso) {
                                case 10:
                                    element.idSTATUS = idStatus;
                                    this.openSnackBar(
                                        "Processo deferido com sucesso!",
                                        "X"
                                    );
                                    break;
                                default:
                                    if (idStatus === 1) {
                                        element.webEsteiraStatus.idStatus =
                                            idStatus;
                                        this.openSnackBar(
                                            "Processo deferido com sucesso!",
                                            "X"
                                        );
                                    }
                                    break;
                            }
                        },
                        (error) => this.openSnackBarError(error, "X")
                    );

                break;
            case 2:
                this.showModal2();

                //this.webProcessoControleService.IndeferirProcesso({ idProcesso: idProcesso, idSolicitacao: idSolicitacao }).subscribe(obj => console.log('indeferiu?'))
                break;
        }
    }

    indeferir() {
        // if (
        //   !this.dadosCadastrais || this.totalDocs != this.docs ||
        //   (this.dependeSeguradora && !this.dadosSeguradora)
        // ) {
        //   var modal = document.getElementById("myModal");

        //   var span = document.getElementsByClassName("close")[0];

        //   modal.style.display = "block";

        //   var text = document.getElementById("textoModal");

        //   text.innerHTML = "Dados pendentes!";

        //   span.addEventListener("click", function () {
        //     modal.style.display = "none";
        //   });

        //   window.onclick = function (event) {
        //     if (event.target == modal) {
        //       modal.style.display = "none";
        //     }
        //   };

        //   return;
        // }

        this.adesaoSelect.icPrimeiroAcesso = "N";
        this.adesaoSelect.webEsteiraStatus.idStatus = 2;
        this.adesaoSelect.webEsteiraStatus.nmStatus = "INDEFERIMENTO";

        this.statusRegistro.nrCpf = this.adesaoSelect.nrCpf;
        this.statusRegistro.idProcesso = 1;
        this.statusRegistro.dtStatus = new Date();
        this.statusRegistro.idStatus =
            this.adesaoSelect.webEsteiraStatus.idStatus;
        this.statusRegistro.nmUsuario = "TRUST";
        this.webStatusRegistroService.Post(this.statusRegistro).subscribe();

        this.adesaoService.PutStatus([this.adesaoSelect]).subscribe();

        this.webHistPlanoParticipante.idPlano = 3;
        this.webHistPlanoParticipante.webEsteiraStatus.idStatus = 2;
        this.webHistPlanoParticipante.webEsteiraStatus.nmStatus =
            "INDEFERIMENTO";

        this.webPlanoParticipante.idPlano = 3;
        this.webPlanoParticipante.webEsteiraStatus.idStatus = 2;
        this.webPlanoParticipante.webEsteiraStatus.nmStatus = "INDEFERIMENTO";

        // this.webPerfilPlanoParticipante.idPlano = 3;
        // this.webPerfilPlanoParticipante.webEsteiraStatus.idStatus = 2;
        // this.webPerfilPlanoParticipante.webEsteiraStatus.nmStatus = "INDEFERIMENTO";

        this.webPlanoParticipanteService
            .Put(this.webPlanoParticipante)
            .subscribe();
        this.webHistPlanoParticipanteService
            .Put(this.webHistPlanoParticipante)
            .subscribe();
        this.webPerfilPlanoParticipanteService
            .Put(this.webPerfilPlanoParticipante)
            .subscribe();

        this.webHistPlanoParticipante.webEsteiraStatus =
            this.adesaoSelect.webEsteiraStatus;
        this.webPlanoParticipante.webEsteiraStatus =
            this.adesaoSelect.webEsteiraStatus;

        this.webHistPlanoParticipanteService.Put(this.webHistPlanoParticipante);
        this.webPlanoParticipanteService.Put(this.webPlanoParticipante);
        this.webPerfilPlanoParticipanteService.Put(
            this.webPerfilPlanoParticipante
        );

        this.ModalController("A Solicitação foi INDEFERIDA");
    }

    checkDados(select: boolean) {
        this.dadosSeguradora = select;
        if (this.webStatusSeguradora) {
            this.webStatusSeguradora.idConfigAdesao =
                this.adesaoSelect.idConfigAdesao;
            this.webStatusSeguradora.idStatus = select ? 2 : 1;
            this.webStatusSeguradoraService
                .Put(this.webStatusSeguradora)
                .subscribe();
        } else {
            this.webStatusSeguradora.idConfigAdesao =
                this.adesaoSelect.idConfigAdesao;
            this.webStatusSeguradora.idStatus = select ? 2 : 1;
            this.webStatusSeguradoraService
                .Post(this.webStatusSeguradora)
                .subscribe();
        }
    }

    goToLinkRE(cpf: string) {
        window.open(
            environment.TrustCRMArHost +
            "Arquivos/Area/Interacao/" +
            cpf +
            "-RE.jpg",
            "_blank"
        );
    }

    goToLink2(doc: string) {
        window.open(
            environment.TrustCRMApiHost + "resources/images/" + doc,
            "_blank"
        );
    }

    goToLink(doc: string) {
        window.open(
            environment.TrustCRMArHost + "Arquivos/Area/Interacao/" + doc,
            "_blank"
        );
    }
    abrirDocumento(url: string) {
        window.open(url, '_blank');
    }

    ModalController(texto: string) {
        var modal = document.getElementById("myModal");

        var span = document.getElementsByClassName("close")[0];

        modal.style.display = "block";

        var text = document.getElementById("textoModal");

        text.innerHTML = texto;

        span.addEventListener("click", function () {
            modal.style.display = "none";
            window.history.back();
        });

        window.onclick = function (event) {
            if (event.target == modal) {
                modal.style.display = "none";
                window.history.back();
            }
        };
    }

    GerarBPD(): void {
        let docName: string =
            "Termo de Opção por Benefício Proporcional Diferido (BPD)";
        let patrocinadora: string = this.empresa.pessoaEmp.nmPessoa;

        let plano: string = this.planos[0].nM_PLANO;
        let cnpb_susep: string = this.planos[0].nR_PLANO_SPC;

        let nomeParticipante: string = this.pessoa.nmPessoa;
        let cpf: string = this.pessoa.nrCnpjCpf;

        let enderecoResidencial: string = `${this.pessoa.nmEndereco}, ${this.pessoa.nrEndereco}`;
        let cidade: string = `${this.pessoa.nmCidade}, ${this.pessoa.sgUF}, Brasil`;
        let telefone: string = this.pessoa.nrTelefone;
        let cep: string = this.pessoa.nrCep;
        let email: string = this.pessoa.nmEmail;

        let registroParticipante: string = this.pessoa.nrMatricula;

        let opcRT: string = "Tabela Progressiva";

        let tipoBeneficio: string = "Benefício Proporcional Diferido";

        var viewPdf = window.open("", "Title");
        viewPdf.document.head.title = "Relatório de BDP";
        if (this.webCliente && this.webCliente.nmCliente == "BASF") {
            viewPdf.document.body.innerHTML = `<div class="wrapper" style="font-family:Arial, Helvetica, sans-serif; padding: 32px;"> <img style="text-align: left" src="	https://www.basf.com/br/images/webprev/logo%20horizontal.png" /> <hr /> <div class="container-fluid" style="text-align: center" > <h3>${docName}</h3> <div class="row" style="text-align: left; width: 100%;"> <div class="column" style="float: left; text-align: left; width: 50%;"> <p style="font-size: small">Patrocinadora: <strong>${patrocinadora}</strong></p> </div> <div class="column" style="float: right; text-align: right; width: 50%;"> <p style="font-size: small">Plano: <strong>${plano}</strong></p> <p style="font-size: small">CNPB/SUSEP: <strong>${cnpb_susep}</strong></p> </div> </div> </div><hr style="width: 100%;"/> <div class="container-fluid"> <h3 style="font-weight: bold;">Dados do Participante</h3> <div class="row"> <p style="font-size: small"> Nome: <strong>${nomeParticipante}</strong></p> <p style="font-size: small"> Registro: <strong>${registroParticipante}</strong></p> </div> <hr /> <div class="row"> <p style="font-size: small">CPF: <strong>${cpf}</strong></p> </div> <hr /> <div class="row" style="width: 100%;"> <div class="column" style="width: 50%; float: left; text-align: left;"> <p style="font-size: small">Endereço Residencial: <strong>${enderecoResidencial}</strong></p> <p style="font-size: small">Telefone: <strong>${telefone}</strong></p> </div> <div class="column" style="width: 50%; float: right; text-align: right;"> <p style="font-size: small">Cidade: <strong>${cidade}</strong></p> <p style="font-size: small">CEP: <strong>${cep}</strong></p> </div> </div> <hr /> <p style="font-size: small">Opção de regime tributário: <strong>${opcRT}</strong></p> <hr /> <p style="font-size: small">Venho, por meio deste Termo optar pelo instituto: <strong>${tipoBeneficio}</strong></p> <hr /> <p style="font-size: small" style="font-size: 14px;"> A opção pelo instituto do benefício proporcional diferido não impede a posterior opção pelo instituto da Portabilidade ou do Resgate de Contribuições, observadas as demais disposições do Regulamento. </p> <div class="row"> <p style="font-size: small" style="border: 1px solid #000000aa; font-size: 12px; color: #0000007e; padding: 4px; text-align: left;"> As informações contidas neste documento são parciais e não substituem a leitura, na integra, do regulamento do plano de benefícios. </p> <h4>Barueri, 13 de maio de 2020</h4> </div> <hr /> <div class="row" style="width: 100%; font-size: small;"> <div class="column" style="width: 70%; float: left; "> <p style="font-size: small">Autenticação eletrônica: <strong>4169587.8502536.3643335</strong></p> </div> <div class="column" style="width: 30%; float: right; "> <p style="font-size: small">Opção enviada em: <strong>13/5/2020 15:52:58</strong></p> </div> </div> <strong> <small> <p style="text-align: center; color: #00000033;">Value Prev Sociedade Previdenciária • Al. Rio Negro, 750 • Barueri - SP CEP 06454-000 Atendimento ao participante: admin.hp-prev@hpe.com • www.hpprev.com.br </p> </small> </strong> </div></div>`;
            viewPdf.window.print();
        } else {
            viewPdf.document.body.innerHTML = `<div class="wrapper" style="font-family:Arial, Helvetica, sans-serif; padding: 32px;"> <img style="text-align: left" src="	https://i.ibb.co/fvdS1Nf/valueprev.png" /> <hr /> <div class="container-fluid" style="text-align: center" > <h3>${docName}</h3> <div class="row" style="text-align: left; width: 100%;"> <div class="column" style="float: left; text-align: left; width: 50%;"> <p style="font-size: small">Patrocinadora: <strong>${patrocinadora}</strong></p> </div> <div class="column" style="float: right; text-align: right; width: 50%;"> <p style="font-size: small">Plano: <strong>${plano}</strong></p> <p style="font-size: small">CNPB/SUSEP: <strong>${cnpb_susep}</strong></p> </div> </div> </div><hr style="width: 100%;"/> <div class="container-fluid"> <h3 style="font-weight: bold;">Dados do Participante</h3> <div class="row"> <p style="font-size: small"> Nome: <strong>${nomeParticipante}</strong></p> <p style="font-size: small"> Registro: <strong>${registroParticipante}</strong></p> </div> <hr /> <div class="row"> <p style="font-size: small">CPF: <strong>${cpf}</strong></p> </div> <hr /> <div class="row" style="width: 100%;"> <div class="column" style="width: 50%; float: left; text-align: left;"> <p style="font-size: small">Endereço Residencial: <strong>${enderecoResidencial}</strong></p> <p style="font-size: small">Telefone: <strong>${telefone}</strong></p> </div> <div class="column" style="width: 50%; float: right; text-align: right;"> <p style="font-size: small">Cidade: <strong>${cidade}</strong></p> <p style="font-size: small">CEP: <strong>${cep}</strong></p> </div> </div> <hr /> <p style="font-size: small">Opção de regime tributário: <strong>${opcRT}</strong></p> <hr /> <p style="font-size: small">Venho, por meio deste Termo optar pelo instituto: <strong>${tipoBeneficio}</strong></p> <hr /> <p style="font-size: small" style="font-size: 14px;"> A opção pelo instituto do benefício proporcional diferido não impede a posterior opção pelo instituto da Portabilidade ou do Resgate de Contribuições, observadas as demais disposições do Regulamento. </p> <div class="row"> <p style="font-size: small" style="border: 1px solid #000000aa; font-size: 12px; color: #0000007e; padding: 4px; text-align: left;"> As informações contidas neste documento são parciais e não substituem a leitura, na integra, do regulamento do plano de benefícios. </p> <h4>Barueri, 13 de maio de 2020</h4> </div> <hr /> <div class="row" style="width: 100%; font-size: small;"> <div class="column" style="width: 70%; float: left; "> <p style="font-size: small">Autenticação eletrônica: <strong>4169587.8502536.3643335</strong></p> </div> <div class="column" style="width: 30%; float: right; "> <p style="font-size: small">Opção enviada em: <strong>13/5/2020 15:52:58</strong></p> </div> </div> <strong> <small> <p style="text-align: center; color: #00000033;">Value Prev Sociedade Previdenciária • Al. Rio Negro, 750 • Barueri - SP CEP 06454-000 Atendimento ao participante: admin.hp-prev@hpe.com • www.hpprev.com.br </p> </small> </strong> </div></div>`;
            viewPdf.window.print();
        }
    }

    GerarSAP(obj): void {
        let docName: string = "Termo de Opção por Autopatrocínio";
        let patrocinadora: string = this.empresa.pessoaEmp.nmPessoa;

        let plano: string = this.planos[0].nM_PLANO;
        let cnpb_susep: string = this.planos[0].nR_PLANO_SPC;

        let nomeParticipante: string = this.pessoa.nmPessoa;
        let cpf: string = this.pessoa.nrCnpjCpf;

        let enderecoResidencial: string = `${this.pessoa.nmEndereco}, ${this.pessoa.nrEndereco}`;
        let cidade: string = `${this.pessoa.nmCidade}, ${this.pessoa.sgUF}, Brasil`;
        let telefone: string = this.pessoa.nrTelefone;
        let cep: string = this.pessoa.nrCep;
        let email: string = this.pessoa.nmEmail;

        let registroParticipante: string = this.pessoa.nrMatricula;

        let opcRT: string = "Tabela Progressiva";

        let tipoBeneficio: string = "Autopatrocínio";

        let basica = obj.pcContribBasica + "%";
        let suplementar = obj.pcContribSuplementar + "%";

        var viewPdf = window.open("", "Title");
        viewPdf.document.body.innerHTML = `<div class="wrapper" style="font-family:Arial, Helvetica, sans-serif; padding: 16px;"> <img style="text-align: left" src="https://i.ibb.co/fvdS1Nf/valueprev.png" /> <hr /> <div class="container-fluid" style="text-align: center" > <h3>${docName}</h3> <div class="row" style="width: 100%; font-size: small;"> <div class="row" style="width: 100%;"> <div class="column" style="text-align: left; width: 50%; float: left;"> <p style="font-size: small;">Patrocinadora: <strong>${patrocinadora}</strong></p> </div> <div class="column" style="width: 50%; float: right; text-align: right;"> <p style="font-size: small;">Plano: <strong>${plano}</strong></p> <p style="font-size: small;">CNPB/SUSEP: <strong>${cnpb_susep}</strong></p> </div> </div> </div> </div> <hr style="width: 100%"/> <div class="container-fluid"> <h3 style="font-weight: bold;">Dados do Participante</h3> <div class="row"> <p style="font-size: small;"> Nome: <strong>${nomeParticipante}</strong></p> <p style="font-size: small;"> Registro: <strong>${registroParticipante}</strong></p> </div> <hr /> <div class="row"> <p style="font-size: small;">CPF: <strong>${cpf}</strong></p> </div> <hr /> <div class="row" style="width: 100%;"> <div class="column" style="width: 50%; float: left; text-align: left;"> <p style="font-size: small;">Endereço Residencial: <strong>${enderecoResidencial}</strong></p> </div> <div class="column" style="width: 50%; float: right; text-align: right;"> <p style="font-size: small;">Cidade: <strong>${cidade}</strong></p> <p style="font-size: small;">CEP: <strong>${telefone}</strong></p> </div> <p style="font-size: small;">Telefone: <strong>${telefone}</strong></p> </div> <hr /> <p style="font-size: small;">Opção de regime tributário: <strong>${opcRT}</strong></p> <hr /> <p style="font-size: small;">Venho, por meio deste Termo optar pelo instituto: <strong>Autopatrocínio</strong></p> <hr /> <p style="font-size: small;"> A opção pelo instituto do benefício proporcional diferido não impede a posterior opção pelo instituto da Portabilidade ou do Resgate de Contribuições, observadas as demais disposições do Regulamento. </p> <h3>Opções do Autopatrocínio</h3> <p style="text-align: justify; font-size: small;"> Conforme condições previstas no item 4.8 do regulamento do plano de benefícios, ao optar pelo autopatrocínio o participante concorda em assumir as Contribuições de Patrocinadora e de Participante, inclusive a Contribuição Especial e aquelas destinadas ao custeio das despesas administrativas, previstas no Capítulo VII do Regulamento. As contribuições serão recolhidas à Sociedade até o décimo dia útil do mês subseqüente ao de competência. No item 7.23 do referido Regulamento constam as penalidades, no caso de inadimplência. O não pagamento das contribuições e/ou despesa administrativa por três meses consecutivos ou alternados, ocasionará a perda da condição de participante do Plano de Benefícios. </p> <table> <colgroup> <col> <col> </colgroup> <thead> <tr> <th></th> <th></th> </tr> <tbody> <tr> <td style="border: 1px solid #000000aa;">Efetuar contribuição básica de </td> <td style="border: 1px solid #000000aa;">${basica}</td> </tr> <tr> <td style="border: 1px solid #000000aa;">Efetuar contribuição suplementar de </td> <td style="border: 1px solid #000000aa;">${suplementar}</td> </tr> </tbody> </thead> </table> <div class="row"> <p style="border: 1px solid #000000aa; font-size: 12px; color: #0000007e; padding: 4px; text-align: left;"> As informações contidas neste documento são parciais e não substituem a leitura, na integra, do regulamento do plano de benefícios. </p> <h4>Barueri, 13 de maio de 2020</h4> </div> <hr /> <div class="row" style="width: 100%; font-size: small;"> <div class="column" style="width: 70%; float: left; "> <p>Autenticação eletrônica: <strong>4169587.8502536.3643335</strong></p> </div> <div class="column" style="width: 30%; float: right; "> <p>Opção enviada em: <strong>13/5/2020 15:52:58</strong></p> </div> </div> <strong> <small> <p style="text-align: center; color: #00000055;">Value Prev Sociedade Previdenciária • Al. Rio Negro, 750 • Barueri - SP CEP 06454-000 Atendimento ao participante: admin.hp-prev@hpe.com • www.hpprev.com.br </p> </small> </strong> </div> </div>`;
        viewPdf.window.print();
    }

    GerarRR55(obj): void {
        let patrocinadora: string = this.empresa.pessoaEmp.nmPessoa;
        let plano: string = this.planos[0].nM_PLANO;

        let status: string = this.nmCategoria;

        // Benefício Requerido
        let saqueAvista: string = obj.pcSaqueAvista + "% sobre saldo atual";
        let valorSaqueAvista: string = obj.vlSaqueAvista.toLocaleString(
            "pt-br",
            { minimumFractionDigits: 2, style: "currency", currency: "BRL" }
        );
        let pagamentoMensal: string = obj.vlBeneficioBruto.toLocaleString(
            "pt-br",
            { minimumFractionDigits: 2, style: "currency", currency: "BRL" }
        );

        // Dados Participante
        let nomeParticipante: string = this.pessoa.nmPessoa;
        let matriculaParticipante: string = this.pessoa.nrMatricula;
        let cpfParticipante: string = this.pessoa.nrCnpjCpf;
        let nascimentoParticipante: string = this.pessoa.dtNascimento
            .toString()
            .slice(0, 10)
            .replace(/-/g, "/");
        let admissao: string = this.pessoa.dtAdmissao
            .toString()
            .slice(0, 10)
            .replace(/-/g, "/");
        let adesao: string = this.planos[0].dT_INI_PLANO
            .toString()
            .slice(0, 10)
            .replace(/-/g, "/");
        let desligamento: string = this.pessoa.dtDemissao
            .toString()
            .slice(0, 10)
            .replace(/-/g, "/");
        let ultContr_mes: string = `1/${this.ultimaContribuicao.nR_MES_REF}/${this.ultimaContribuicao.nR_ANO_REF}`;
        let estCivil: string = this.listaEstadoCivil.find(
            (x) => x.idEstadoCivil == this.pessoa.idEstadoCivil
        ).nmEstadoCivil;

        let ppe: string = this.pessoa.icExposta == "S" ? "Sim" : "Não";
        let rne: string = this.pessoa.icResidExterior == "S" ? "Sim" : "Não";

        // Endereço de Correspondência
        let endereco: string = `${this.pessoa.nmEndereco} ${this.pessoa.nrEndereco} ${this.pessoa.nmComplemento}`;
        let bairro: string = this.pessoa.nmBairro;
        let cidade: string = this.pessoa.nmCidade;
        let uf: string = this.pessoa.sgUF;
        let cep: string = this.pessoa.nrCep;
        let email: string = this.pessoa.nmEmail;
        let telefone: string = this.pessoa.nrTelefone;

        // Informações da Instituição Financeira para Recebimento do Benefício
        let banco: string = this.dadosBancariosADO.nM_BANCO;
        let agencia: string = this.dadosBancariosADO.nR_AG_BANCO;
        let conta: string = this.dadosBancariosADO.nR_CONTA_BANCO;
        let tipo: string =
            this.dadosBancariosADO.iD_TIPO_CONTA == 1 ? "Poupança" : "Corrente";
        let dep = "";

        this.listaDependentes.map((dependente) => {
            dep += `<tr>
      <td style=" border-left: 1px solid #333; border-bottom: 1px solid #333;">${dependente.pessoa.nmPessoa
                }</td>
      <td style=" border-left: 1px solid #333; border-bottom: 1px solid #333;">${dependente.idParentesco
                }</td>
      <td style=" border-left: 1px solid #333; border-bottom: 1px solid #333;">${dependente.pessoa.dtNascimento
                    .toString()
                    .slice(0, 10)
                    .replace(/-/g, "/")}</td>
      <td style=" border-left: 1px solid #333; border-bottom: 1px solid #333;">${dependente.pessoa.icSexo == "M" ? "Masculino" : "Feminino"
                }</td>
      <td style=" border-left: 1px solid #333; border-bottom: 1px solid #333;">${this.listaFinalidade.find(
                    (x) => x.idFinalidade == dependente.idFinalidade
                ).nmFinalidade
                }</td>
      <td style=" border-left: 1px solid #333; border-bottom: 1px solid #333; border-right: 1px solid #333;">${dependente.icInvalido == "S" ? "Sim" : "Não"
                }}</td>
   </tr>`;
        });

        // Perfil de Investimento - HP - CNPB 1996.0026-19
        let carteira: string = "";
        let rendaFixa: string = "85% a 100%";
        let rendaVariavel: string = "0% a 15%";

        if (obj.idPerfil == 1) {
            carteira = "Super Conservador";
            rendaFixa = "100%";
            rendaVariavel = "0%";
        } else if (obj.idPerfil == 2) {
            carteira = "Conservador";
            rendaFixa = "46% a 85%";
            rendaVariavel = "6% a 14%";
        }

        var viewPdf = window.open("", "Title");
        viewPdf.document.body.innerHTML = `<!DOCTYPE html> <html lang="en"> <head> <meta charset="UTF-8"> <meta name="viewport" content="width=device-width, initial-scale=1.0"> <title>Document</title> </head> <body> <div class="wrapper" style="font-family:Arial, Helvetica, sans-serif; padding: 32px; font-size: small; "> <img style="text-align: left" src="https://i.ibb.co/fvdS1Nf/valueprev.png" /> <hr /> <p style="text-align: center; color: #33333355; font-weight: 600;">Esta mensagem é gerada por computador. Não utilize o comando reply.</p> <p style="text-align: center;">VALUE PREV SOCIEDADE PREVIDENCIARIA</p> <p style="font-weight: 700; margin-bottom: 8px; text-align: center; font-size: medium;">Requerimento de Benefício</p> <table style="border-spacing: 0px; width: 100%;"> <tr> <td style=" border-left: #333333 1px solid; border-bottom: #333333 1px solid; border-top: #333333 1px solid;"> <span>Patrocinadora:<br/> <strong>${patrocinadora}</strong></span> </td> <td style=" border-bottom: #333333 1px solid; border-top: #333333 1px solid; border-right: #333333 1px solid; border-left: #333333 1px solid; "> <span>Plano:<br/><strong>${plano}</strong></span> </td> </tr> </table>

    <p style="font-weight: 700; margin-bottom: 4px;">Benefício Requerido</p> <table style="border-spacing: 0px; width: 100%"> <tr> <td style=" border-bottom: #333333 1px solid; border-left: #333333 1px solid; border-top: #333333 1px solid;"> <span>Saque a Vista:</span> </td> <td style=" border-left: #333333 1px solid; border-bottom: #333333 1px solid; border-top: #333333 1px solid;"> <strong>${saqueAvista}</strong> </td> <td style=" border-left: #333333 1px solid; border-bottom: #333333 1px solid; border-top: #333333 1px solid; border-right: #333333 1px solid;"> <span>Valor do saque a vista: <strong>${valorSaqueAvista}</strong></span> </td> </tr> <tr> <td style=" border-bottom: #333333 1px solid; border-left: #333333 1px solid;"><span>Pagamento Mensal:</span></td> <td style=" border-left: #333333 1px solid; border-bottom: #333333 1px solid;"><strong>${pagamentoMensal}</strong></td> <td style=" border-bottom: #333333 1px solid; border-right: #333333 1px solid;"></td> </tr> </table>
   
    <p style="font-weight: 700; margin-bottom: 4px;">Dados do Participante</p> <table style="border-spacing: 0px; width: 100%"> <tr> <td style=" border-left: #333333 1px solid; border-bottom: #333333 1px solid; border-top: #333333 1px solid;"> <span>${nomeParticipante}</span> </td> <td style=" border-bottom: #333333 1px solid; border-top: #333333 1px solid; "></td> <td style=" border-left: #333333 1px solid; border-bottom: #333333 1px solid; border-top: #333333 1px solid; "> <span>Matricula <strong>${matriculaParticipante}</strong></span> </td> <td style=" border-bottom: #333333 1px solid; border-top: #333333 1px solid; "></td> <td style=" border-bottom: #333333 1px solid; border-top: #333333 1px solid; "></td> <td style=" border-left: #333333 1px solid; border-bottom: #333333 1px solid; border-top: #333333 1px solid; border-right: #333333 1px solid; "> <span>CPF <strong>${cpfParticipante}</strong></span> </td> </tr> <tr> <td style=" border-bottom: #333333 1px solid; border-left: #333333 1px solid;"> <span> Nascimento<br/><strong>${nascimentoParticipante}</strong></span> </td> <td style=" border-left: #333333 1px solid; border-bottom: #333333 1px solid;"> <span> Admissão<br/><strong>${admissao}</strong></span> </td> <td style=" border-left: #333333 1px solid; border-bottom: #333333 1px solid;"> <span> Adesão<br/><strong>${adesao}</strong></span> </td> <td style=" border-bottom: #333333 1px solid; border-left: #333333 1px solid;"> <span> Desligamento<br/><strong>${desligamento}</strong></span> </td> <td style=" border-left: #333333 1px solid; border-bottom: #333333 1px solid;"> <span>Ult.Contr/mes<br/><strong>${ultContr_mes}</strong></span> </td> <td style=" border-left: #333333 1px solid; border-bottom: #333333 1px solid; border-right: #333333 1px solid;"> <span>Est.Civil<br/><strong>${estCivil}</strong></span> </td> </tr> <tr> <td style=" border-bottom: #333333 1px solid; border-left: #333333 1px solid;"> <span>Status <strong>${status}</strong></span> </td> <td style="border-bottom: #333333 1px solid;"></td> <td style="border-bottom: #333333 1px solid;"></td> <td style=" border-bottom: #333333 1px solid; border-LEFT: #333333 1px solid;"> <span>Pessoa Politicamente Exposta (s/n) <strong>${ppe}</strong></span> </td> <td style="border-bottom: #333333 1px solid;"></td> <td style=" border-bottom: #333333 1px solid; border-right: #333333 1px solid;"> </td> </tr> <tr> <td style=" border-bottom: #333333 1px solid; border-left: #333333 1px solid;"> <span>Residente no Exterior (s/n) <strong>${rne}</strong></span> </td> <td style="border-bottom: #333333 1px solid;"></td> <td style="border-bottom: #333333 1px solid;"></td> <td style="border-bottom: #333333 1px solid;"></td> <td style="border-bottom: #333333 1px solid;"></td> <td style=" border-bottom: #333333 1px solid; border-right: #333333 1px solid;"></td> </tr> </table>
   
    <p style="font-weight: 700; margin-bottom: 4px;">Endereço de Correspondência</p> <table style="border-spacing: 0px; width: 100%;"> <tr> <td style=" border-left: #333333 1px solid; border-bottom: #333333 1px solid; border-top: #333333 1px solid;"> <span>Endereço:<br/> <strong>${endereco}</strong></span> </td> <td style=" border-bottom: #333333 1px solid; border-top: #333333 1px solid;"></td> <td style=" border-bottom: #333333 1px solid; border-top: #333333 1px solid;"></td> <td style=" border-right: #333333 1px solid; border-bottom: #333333 1px solid; border-top: #333333 1px solid;"></td> </tr> <tr> <td style=" border-bottom: #333333 1px solid; border-right: #333333 1px solid; border-left: #333333 1px solid; "> <span>Bairro:<br/><strong>${bairro}</strong></span> </td> <td style=" border-bottom: #333333 1px solid; border-right: #333333 1px solid; "> <span>Cidade:<br/><strong>${cidade}</strong></span> </td> <td style=" border-bottom: #333333 1px solid; border-right: #333333 1px solid; "> <span>UF:<br/><strong>${uf}</strong></span> </td> <td style=" border-bottom: #333333 1px solid; border-right: #333333 1px solid; "> <span>CEP:<br/><strong>${cep}</strong></span> </td> </tr> <tr> <td style=" border-bottom: #333333 1px solid; border-left: #333333 1px solid; "> <span>Email:<br/><strong>${email}</strong></span> </td> <td style="border-bottom: #333333 1px solid;"></td> <td style=" border-left: #333333 1px solid; border-bottom: #333333 1px solid;"> <span>Telefone:<br/><strong>${telefone}</strong></span> </td> <td style=" border-bottom: #333333 1px solid; border-right: #333333 1px solid; "> </td> </tr> </table>
   
    <p style="font-weight: 700; margin-bottom: 4px;">Informações da Instituição Financeira para Recebimento do Benefício</p> <table style="border-spacing: 0px; width: 100%"> <tr> <td style=" border-left: #333333 1px solid; border-top: #333333 1px solid; border-bottom: #333333 1px solid; "> <span>Banco:<br/> <strong>${banco}</strong></span> </td> <td style=" border-left: #333333 1px solid; border-top: #333333 1px solid; border-bottom: #333333 1px solid; "> <span>Agência:<br/><strong>${agencia}</strong></span> </td> <td style=" border-top: #333333 1px solid; border-left: #333333 1px solid; border-bottom: #333333 1px solid; "> <span>Conta:<br/><strong>${conta}</strong></span> </td> <td style=" border-top: #333333 1px solid; border-left: #333333 1px solid; border-bottom: #333333 1px solid; border-right: #333333 1px solid; "> <span>Tipo:<br/><strong>${tipo}</strong></span> </td> </tr> </table>
   
    <p style="font-weight: 700; margin-bottom: 4px;">Dados dos Beneficiários e Dependentes para fins de IR</p> <table style="border-spacing: 0px; width: 100%"> <table style="width: 100%; text-align: left; border-spacing: 0px;"> <thead> <th style=" border-top: 1px solid #333; border-left: 1px solid #333; border-bottom: 1px solid #333;">Nome Completo</th> <th style=" border-top: 1px solid #333; border-left: 1px solid #333; border-bottom: 1px solid #333;">Parentesco</th> <th style=" border-top: 1px solid #333; border-left: 1px solid #333; border-bottom: 1px solid #333;">Nascimento</th> <th style=" border-top: 1px solid #333; border-left: 1px solid #333; border-bottom: 1px solid #333;">Sexo</th> <th style=" border-top: 1px solid #333; border-left: 1px solid #333; border-bottom: 1px solid #333;">Finalidade</th> <th style=" border-top: 1px solid #333; border-left: 1px solid #333; border-bottom: 1px solid #333; border-right: 1px solid #333;">Invalido</th> </thead> <tbody> ${dep} </tbody> </table> </table>
   
    <p style="font-weight: 700; margin-bottom: 4px;">Perfil de Investimento - HP - CNPB 1996.0026-19</p> <table style="border-spacing: 0px; width: 100%"> <tr> <td style=" border-left: #333333 1px solid; border-top: #333333 1px solid; border-bottom: #333333 1px solid; "> <span>Carteira:<br/> <strong>${carteira}</strong></span> </td> <td style=" border-left: #333333 1px solid; border-top: #333333 1px solid; border-bottom: #333333 1px solid; "> <span>Renda Fixa:<br/><strong>${rendaFixa}</strong></span> </td> <td style=" border-top: #333333 1px solid; border-left: #333333 1px solid; border-bottom: #333333 1px solid; "> <span>Renda Variavel:<br/><strong>${rendaVariavel}</strong></span> </td> </tr> </table> <p> Nos termos do regulamento do plano de benefícios da Value Prev, venho pelo presente requerer o benefício acima assinalado, comprometendo-me a comunicar a Value Prev qualquer alteração </p> <p style="font-weight: 700; text-align: center; font-size: medium;"> Outras Informações - Requerimento </p> <p style="text-align: center;">Ciente de que os procedimentos para atendimento ao meu requerimento somente serão iniciados com o envio dos documentos abaixo solicitados de todos os beneficiarios relacionados</p>
   
    <p style="text-align: center; font-weight: 700; color: dimgray;"> VALUE PREV SOCIEDADE PREVIDENCIARIA • Al. Rio Negro, 750 • Barueri - SP • CEP 06454-000 Atendimento ao participante: admin.hp-prev@hpe.com • www.hpprev.com.br </p> </div> </body> </html>`;
        viewPdf.window.print();
    }

    GerarResgateNormal(obj): void {
        let docName: string = "Termo de Opção por Autopatrocínio";
        let patrocinadora: string = this.empresa.pessoaEmp.nmPessoa;
        let plano: string = this.planos[0].nM_PLANO;
        let cnpb_susep: string = this.planos[0].nR_PLANO_SPC;
        let nomeParticipante: string = this.pessoa.nmPessoa;
        let cpf: string = this.pessoa.nrCnpjCpf;
        let enderecoResidencial: string = `${this.pessoa.nmEndereco}, ${this.pessoa.nrEndereco}`;
        let cidade: string = `${this.pessoa.nmCidade}, ${this.pessoa.sgUF}, Brasil`;
        let telefone: string = this.pessoa.nrTelefone;
        let registroParticipante: string = this.pessoa.nrMatricula;
        let opcRT: string = "Tabela Progressiva";

        let basica = obj.pcContribuicaoBasica + "%";
        let suplementar = obj.pcContribuicaoSuplementar + "%";

        var viewPdf = window.open("", "Title");
        viewPdf.document.body.innerHTML = `<div class="wrapper" style="font-family:Arial, Helvetica, sans-serif; padding: 16px;"> <img style="text-align: left" src="https://i.ibb.co/fvdS1Nf/valueprev.png" /> <hr /> <div class="container-fluid" style="text-align: center" > <h3>${docName}</h3> <div class="row" style="width: 100%; font-size: small;"> <div class="row" style="width: 100%;"> <div class="column" style="text-align: left; width: 50%; float: left;"> <p style="font-size: small;">Patrocinadora: <strong>${patrocinadora}</strong></p> </div> <div class="column" style="width: 50%; float: right; text-align: right;"> <p style="font-size: small;">Plano: <strong>${plano}</strong></p> <p style="font-size: small;">CNPB/SUSEP: <strong>${cnpb_susep}</strong></p> </div> </div> </div> </div> <div class="container-fluid"> <h3 style="font-weight: bold;">Dados do Participante</h3> <div class="row"> <p style="font-size: small;"> Nome: <strong>${nomeParticipante}</strong></p> <p style="font-size: small;"> Registro: <strong>${registroParticipante}</strong></p> </div> <hr /> <div class="row"> <p style="font-size: small;">CPF: <strong>${cpf}</strong></p> </div> <hr /> <div class="row" style="width: 100%;"> <div class="column" style="width: 50%; float: left; text-align: left;"> <p style="font-size: small;">Endereço Residencial: <strong>${enderecoResidencial}</strong></p> </div> <div class="column" style="width: 50%; float: right; text-align: right;"> <p style="font-size: small;">Cidade: <strong>${cidade}</strong></p> <p style="font-size: small;">CEP: <strong>${telefone}</strong></p> </div> <p style="font-size: small;">Telefone: <strong>${telefone}</strong></p> </div> <hr /> <p style="font-size: small;">Opção de regime tributário: <strong>${opcRT}</strong></p> <hr /> <p style="font-size: small;">Venho, por meio deste Termo optar pelo instituto: <strong>Autopatrocínio</strong></p> <hr /> <p style="font-size: small;"> A opção pelo instituto do benefício proporcional diferido não impede a posterior opção pelo instituto da Portabilidade ou do Resgate de Contribuições, observadas as demais disposições do Regulamento. </p> <h3>Opções do Autopatrocínio</h3> <p style="text-align: justify; font-size: small;"> Conforme condições previstas no item 4.8 do regulamento do plano de benefícios, ao optar pelo autopatrocínio o participante concorda em assumir as Contribuições de Patrocinadora e de Participante, inclusive a Contribuição Especial e aquelas destinadas ao custeio das despesas administrativas, previstas no Capítulo VII do Regulamento. As contribuições serão recolhidas à Sociedade até o décimo dia útil do mês subseqüente ao de competência. No item 7.23 do referido Regulamento constam as penalidades, no caso de inadimplência. O não pagamento das contribuições e/ou despesa administrativa por três meses consecutivos ou alternados, ocasionará a perda da condição de participante do Plano de Benefícios. </p> <table> <colgroup> <col> <col> </colgroup> <thead> <tr> <th></th> <th></th> </tr> <tbody> <tr> <td style="border: 1px solid #000000aa;">Efetuar contribuição básica de </td> <td style="border: 1px solid #000000aa;">${basica}</td> </tr> <tr> <td style="border: 1px solid #000000aa;">Efetuar contribuição suplementar de </td> <td style="border: 1px solid #000000aa;">${suplementar}</td> </tr> </tbody> </thead> </table> <div class="row"> <p style="border: 1px solid #000000aa; font-size: 12px; color: #0000007e; padding: 4px; text-align: left;"> As informações contidas neste documento são parciais e não substituem a leitura, na integra, do regulamento do plano de benefícios. </p> <h4>Barueri, 13 de maio de 2020</h4> </div> <hr /> <div class="row" style="width: 100%; font-size: small;"> <div class="column" style="width: 70%; float: left; "> <p>Autenticação eletrônica: <strong>4169587.8502536.3643335</strong></p> </div> <div class="column" style="width: 30%; float: right; "> <p>Opção enviada em: <strong>13/5/2020 15:52:58</strong></p> </div> </div> <strong> <small> <p style="text-align: center; color: #00000055;">Value Prev Sociedade Previdenciária • Al. Rio Negro, 750 • Barueri - SP CEP 06454-000 Atendimento ao participante: admin.hp-prev@hpe.com • www.hpprev.com.br </p> </small> </strong> </div> </div>`;
        viewPdf.window.print();
    }

    GerarRelatorio(relatorio: string, obj: any): void {
        switch (relatorio) {
            case "BPD":
                this.GerarBPD();
                break;
            case "SAP":
                this.GerarSAP(obj);
                break;
            case "resgateNormal":
                this.GerarResgateNormal(obj);
                break;
            case "beneficio":
                this.GerarRR55(obj);
                break;
            //case "portabilidade" : this.GerarPortabilidae(); break;
        }
    }
    // No seu WebPlanoAdesao.component.ts (ou onde estiver o seu loop)

    formatarTelefone(telefone: string): string {
        if (!telefone) return '';
        // Remove tudo que não for dígito
        const telLimpo = telefone.replace(/\D/g, '');

        // 11 dígitos (Celular)
        if (telLimpo.length === 11) {
            return `(${telLimpo.substring(0, 2)}) ${telLimpo.substring(2, 7)}-${telLimpo.substring(7)}`;
        }
        // 10 dígitos (Fixo ou celular antigo)
        if (telLimpo.length === 10) {
            return `(${telLimpo.substring(0, 2)}) ${telLimpo.substring(2, 6)}-${telLimpo.substring(6)}`;
        }

        // Retorna o número original se não tiver o tamanho esperado
        return telefone;
    }

    // GerarSB():void {
    //   var viewPdf = window.open("", "Title");
    //   viewPdf.document.body.innerHTML = '<div class="wrapper" style="font-family:Arial, Helvetica, sans-serif; padding: 32px;"> <div class="container"> <img style="text-align: left" src="https://i.ibb.co/fvdS1Nf/valueprev.png" /> <hr /> <div class="container-fluid" style="text-align: center" > <h3>Termo de Opção por Benefício Proporcional Diferido (BPD)</h3> <div class="row" style="text-align: left"> <p>Patrocinadora: <strong>Enterprise Services Brasil Serviços de Tecnologia Ltda</strong></p> <p>Plano: <strong>Plano HP</strong></p> <p>CNPB/SUSEP: <strong>19.960.026-19</strong></p> </div> </div> <hr /> <div class="container-fluid"> <h2 style="font-weight: bold;">Dados do Participante</h2> <div class="row"> <p> Nome: <strong>Ricardo Conegliam</strong></p> <p> Registro: <strong>81022871</strong></p> </div> <hr /> <div class="row"> <p>CPF: <strong>177.506.668-18</strong></p> </div> <hr /> <div class="row"> <p>Endereço Residencial: <strong>ALAMEDA MALBEC, 544</strong></p> <div class="row"> <p>Cidade: <strong>Barueru, SP, Brasil</strong></p> <p>CEP: <strong>06458-285</strong></p> </div> <p>Telefone: <strong>11 99242-0694</strong></p> </div> <hr /> <p>Opção de regime tributário: <strong>Tabela Progressiva</strong></p> <hr /> <p>Venho, por meio deste Termo optar pelo instituto: <strong>Benefícios Proporcional Diferido</strong></p> <hr /> <p style="font-size: 14px;"> A opção pelo instituto do benefício proporcional diferido não impede a posterior opção pelo instituto da Portabilidade ou do Resgate de Contribuições, observadas as demais disposições do Regulamento. </p> <div class="row"> <p style="border: 1px solid #000000aa; font-size: 12px; color: #0000007e; padding: 4px; text-align: left;"> As informações contidas neste documento são parciais e não substituem a leitura, na integra, do regulamento do plano de benefícios. </p> <h4>Barueri, 13 de maio de 2020</h4> </div> <hr /> <p>Autenticação eletrônica: <strong>4169587.8502536.3643335</strong></p> <p>Opção enviada em: <strong>13/5/2020 15:52:58</strong></p></div> </div> </div>';
    //   viewPdf.window.print();
    // }
}
